import { Component, ElementRef, OnInit, Input, Injector, NgZone, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AsideUiEngineComponent } from '../../aside-ui-engine/aside-ui-engine.component';
import { DynamicPopUpComponent } from '../../data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { PopupFormComponent } from "src/modules/base/components/popupform/popupform.component";
import { AlertsService } from '../../../services/alerts.service';
import { AsideBarService } from '../../../services/asideBar.service';
import { FilterService } from '../../../services/filter.service';
import { LoaderService } from '../../../services/loader.service';
import { ModalService } from '../../../services/modal.service';
import { ModalSize, SmartModalService } from '../../../services/smart-modal.service';
import { UtilService } from '../../../services/util.service';
import { AppService } from '../../../shared/services/app.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { BaseService } from '../../../shared/services/base.service';
import { RolePermissionService } from '../../../shared/services/role-permission.service';
import { StorageService } from '../../../shared/services/storage.service';
import { DateRangeConfig } from '../../daterangepicker/dateconfig.service';
import { PrintService } from '../../../shared/services/print.service';
import { PreferenceService } from '../../../shared/services/preference.service';
import { DiacomViewerComponent } from "src/modules/base/components/viewer/diacom-viewer/diacom-viewer.component";
import { ManageFilterComponent } from '../../data-grid/manage-filter/manage-filter.component';
import _moment from 'proxies/dayjs';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { PDFDocument } from 'src/assets/js/pdf-lib.min.js';
import { Subscription } from 'rxjs';
const moment = _moment

@Component({
    selector: 'app-common-viewer',
    templateUrl: './common-viewer.component.html',
    styleUrls: ['./common-viewer.component.scss'],
    standalone: false
})

export class CommonViewerComponent implements OnInit, OnDestroy {
  @Input() resource: any; @Input() bannerData: any;
  @Input() bannerJson: any; hideEditForm: boolean = false;
  @Input() tabLayoutName:any;
  // newPrintEnable: any;
  templateChecked: any; listenToKeyboard: boolean = true;
  currentResource: any;
  copyRuleAllowed: boolean = true; // copy rule result; true unless the rule API explicitly restricts copy
  copyRuleRemark: string = ''; // rule remark shown when copy is restricted
  archiveConfig: any = {}
  addendumHistoryOpen: boolean = false;
  addendumHistoryLabel: string = '';
  currentData: any = {
    decorator: '',
    versionVal: '',
    isValid: true,
    fields: [],
    APIResource: {},
    cardData: {},
    configForDocument: {
      showTypeDropdown: false
    },
    show: true
  };
  pagination: any = {
    page_size: 10,
    page_no: 0,
    selected_index: 0,
  };
  noObservationFound: boolean = false;
  filter = { filter: '', pseudoFilter: '' };
  search: string = ""; serVal: any;
  showHistory: boolean = true;
  viewOnly: boolean;
  showImageView: boolean = false;
  currentPrescription: any;
  isPinRequired: boolean = false;
  secondListView: any;
  config: any = {};
  activeValue: any = 0;
  default_quick_filter: any = { selected: false, data: {} };
  hideEdit: boolean = false;
  pre_print_check: boolean = true;
  cancel_button_hide: boolean = false;
  complex_search_value: any;
  getAmountConfigValue: boolean = false;
  pacs_integration: boolean = false;
  closeAsideOnCloseBtn: boolean = false;
  dischargePatientList: boolean;
  currentDoctor: { confidentialDepartmentId: string; confidentialDepartment: string; };
  isDropdownOpen: any;
  private readonly paginationStorageKey = 'commonViewerPaginationMap';
  private currentButtonAction: string = '';
  private paginationInitialized: boolean = false;
  private paginationRestoredFor: string | null = null;
  private readonly initialFilterValue: string = '';
  private isInitialFilterCaptured: boolean = false;
  userRole: string = '';
  templateFormName:any=''
  isExpandableField : boolean = false;
  isPrintOpenInPopup: boolean = false;
  isPrintPopupActive: boolean = false;
  private printPopupSubscription: Subscription = new Subscription();
  // Listens for AsideBarService.setRefresh(true) to re-fetch the current page (ticket #195471).
  private pageRefreshSubscription: Subscription = new Subscription();
  protected closeBtnSubscription: Subscription = new Subscription();
  selectedItemsForCumulativePrint: any[] = [];
  isCumulativePrinting: boolean;
  MAX_SELECTION_LIMIT: number = 10;
  labBulkPrintItem: any[] = [];
  constructor(public baseService: BaseService,
    public elementRef: ElementRef,
    public ngZone: NgZone,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public loader: LoaderService,
    public appService: AppService,
    public asideBarService: AsideBarService,
    public preferenceService: PreferenceService,
    public alerts: AlertsService,
    public modalService: ModalService,
    public smartModalService: SmartModalService,
    public dialogService: DialogService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public utilService: UtilService,
    public filterService: FilterService,
    public communicationService: CommunicationService,
    public rolePermissionService?: RolePermissionService,
    public injector?: Injector,
    public dialogConfig?: DialogConfig,
    public dialogRef?: DialogRef,
    public printService?: PrintService,
    public utilitiesService?: UtilitiesService,
  ) { }

  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if(this.listenToKeyboard){
  //     if (event.key === 'ArrowLeft') {
  //       this.prevImage()
  //     } else if(event.key === 'ArrowRight') {
  //       this.nextImage()
  //     }
  //   }
  // }
  @HostListener('document:click', ['$event']) // mobile capbility show or hide 
    closeMenu(event: Event) {   
        const target = event.target as HTMLElement;
        if (!target.closest('._table-quick-actions') && !target.closest('.card-three-dots-container')) {
        this.isDropdownOpen = false;
        const menu = document.querySelector('._table-quick-actions.show');
          if (menu) menu.classList.remove('show');
            }
    }


  /**
   * Ensures pagination state is restored from sessionStorage for the current resource
   * Prevents multiple restoration attempts for the same resource
   * @returns boolean indicating whether pagination was restored
   */
  private ensurePaginationRestored(): boolean {
    if (!this.currentResource) return false;
    
    // Only restore once per resource to prevent duplicate operations
    if (this.paginationRestoredFor === this.currentResource) {
      return true; // Already restored
    }
    
    console.log(`Auto-restoring pagination for ${this.currentResource}`);
    
    const map = this.getPaginationStateMap();
    const state = map[this.currentResource];
    
    if (state) {
      const currentHasFilters = this.hasActiveFilters();
      const savedHadFilters = state.has_active_filters || false;

      if (savedHadFilters && !currentHasFilters) {
        console.log(`Filter state mismatch detected. Saved state had filters but current doesn't. Resetting pagination.`);
        this.paginationInitialized = true;
        this.paginationRestoredFor = this.currentResource;
        return false; // Don't restore, let it reset
      }

      const pageNo = Number(state.page_no);
      const selIdx = Number(state.selected_index);
      
      // Restore pagination state with validation
      this.pagination.page_no = (!isNaN(pageNo) && pageNo >= 0) ? pageNo : 0;
      const validSelIdx = (!isNaN(selIdx) && selIdx >= 0) ? selIdx : 0;
      this.pagination.selected_index = validSelIdx;
      this.activeValue = validSelIdx;
      
      // Mark as restored to prevent duplicate restoration
      this.paginationRestoredFor = this.currentResource;
      this.paginationInitialized = true;
      
      console.log(`Pagination auto-restored: Page ${this.pagination.page_no}, Index ${validSelIdx}`);
      return true;
    }
    
    // Mark as initialized even if no state to restore
    this.paginationInitialized = true;
    this.paginationRestoredFor = this.currentResource;
    return false;
  }


  /**
   * Retrieves pagination state map from sessionStorage
   * Handles JSON parsing errors gracefully
   * @returns object containing pagination states for all resources
   */
  private getPaginationStateMap(): any {
    try { return JSON.parse(sessionStorage.getItem(this.paginationStorageKey) || '{}'); } catch { return {}; }
  }

  /**
   * Saves current pagination state to sessionStorage
   * Only saves if pagination has been properly initialized to avoid saving incorrect state
   */
  private savePaginationState(): void {
    if (!this.currentResource) return;
    
    // Don't save until pagination is properly initialized
    if (!this.paginationInitialized) {
      console.log(`Deferring pagination save - not initialized yet`);
      return;
    }

    const map = this.getPaginationStateMap();
    const currentState = {
      page_no: this.pagination.page_no || 0,
      selected_index: this.pagination.selected_index || 0,
      has_active_filters: this.hasActiveFilters(),
      timestamp: Date.now()
    };
    
    map[this.currentResource] = currentState;
    sessionStorage.setItem(this.paginationStorageKey, JSON.stringify(map));
    console.log(`Pagination saved for ${this.currentResource}:`, currentState);
  }

  /**
 * Captures the initial filter value to be used as a baseline for comparison
 * This should only be called once when the component initializes
 */
  private captureInitialFilterValue(): void {
    if (!this.isInitialFilterCaptured) {
      // Store the initial filter value (could be empty string or have default filters)
      (this as any).initialFilterValue = this.filter.filter || '';
      this.isInitialFilterCaptured = true;
      console.log('Initial filter value captured:', this.initialFilterValue);
    }
  }


  /**
 * Checks if there are currently active filters or search terms
 * @returns boolean indicating if filters are active
 */
  private hasActiveFilters(): boolean {

    let hasFilter = false;
    if (this.filter.filter && this.filter.filter.trim() !== "") {
      this.captureInitialFilterValue();
    }
    if (this.filter.filter && this.filter.filter.trim() !== '') {
      let filterStr = this.filter.filter.trim();
      
      // Remove the static part if it exists
      if (filterStr.startsWith(this.initialFilterValue)) {
        filterStr = filterStr.replace(this.initialFilterValue, '').trim();
        // Remove leading comma if present after removing the static part
        if (filterStr.startsWith(',')) {
          filterStr = filterStr.substring(1).trim();
        }
      }
      
      // Check if there are any remaining filters
      hasFilter = filterStr !== '';
    }
    
    // Check if there's an active search
    const hasSearch = this.search && this.search.trim() !== '';
    
    // Check if there's a complex search
    const hasComplexSearch = this.complex_search_value && 
      (typeof this.complex_search_value === 'object' || 
      (typeof this.complex_search_value === 'string' && this.complex_search_value.trim() !== ''));

    return hasFilter || hasSearch || hasComplexSearch;
  }


  /**
   * Loads pagination state for the current resource
   * @returns selected index if pagination was restored, null otherwise
   */
  private loadPaginationState(): number | null {
    return this.ensurePaginationRestored() ? this.pagination.selected_index : null;
  }



  ngOnInit() {
    // this.serVal = this.utilitiesService.documentArrowUpTarget
    //   .subscribe(target => this.prevImage());
    // this.serVal = this.utilitiesService.documentArrowDownTarget
    //   .subscribe(target => this.nextImage());
    // this.serVal = this.utilitiesService.documentArrowLeftTarget
    //   .subscribe(target => this.prevImage());
    // this.serVal = this.utilitiesService.documentArrowRightTarget
    //   .subscribe(target => this.nextImage());
    // this.newPrintEnable = false;
    // this.templateChecked = false;
    this.printPopupSubscription.add(
      this.utilService.printPopup$.subscribe(
          (val: boolean) => {
            this.isPrintPopupActive = val;
          }
      )
    );
    // Re-fetches the current page after a decorator action (e.g. DiagnosticReport.markAsPrinted)
    // that bypasses hitPostAPI/hitDecorator. Gated by refreshCurrentPageOnAction so unrelated
    // setRefresh(true) callers (e.g. care_plan.ts) don't affect screens that didn't opt in.
    this.pageRefreshSubscription.add(
      this.asideBarService.getRefresh().subscribe((val: boolean) => {
        if (val === true && this.currentData?.resouceDef?.config?.refreshCurrentPageOnAction === true) {
          this.filterClick(this.search, { pageNo: this.pagination.page_no, restoreIndex: this.pagination.selected_index });
          this.asideBarService.setRefresh(false);
        }
      })
    );
    try {
      const storedRole = localStorage.getItem('CURRENT_ROLE');
      if (storedRole) {
        const roleObj = JSON.parse(storedRole);
        this.userRole = roleObj.role || '';
        console.log('Current user role:', this.userRole);
      }
    } catch (error) {
      console.error('Error parsing CURRENT_ROLE from localStorage:', error);
      this.userRole = '';
    }
    
    try {
      if (this.dialogConfig?.data?.inPopup == true && !this.utilService?.isMobile()) {
        this.dialogConfig.data.inPopup = false
      }
    }
    catch (e) {
    }
    this.closeBtnSubscription.add(this.asideBarService.closeBtnClicked_val.subscribe((res) => {
      if (res) {
        this.closeAsideOnCloseBtn = true;
        this.hideEditForm = false;
        let data = JSON.parse(sessionStorage.getItem("curr_epres_unsaved_forms") || "{}")
        if (this.templateFormName && data?.[this.templateFormName]) {
        delete data[this.templateFormName];
        sessionStorage.setItem("curr_epres_unsaved_forms", JSON.stringify(data));
        //localStorage.removeItem("savedTemplateName");
    }
      }
    }))
    this.bannerJson = this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.bannerJson ? this.dialogConfig.data.bannerJson : this.bannerJson;
    if (this.resource == undefined)
      this.resource = this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.resource ? this.dialogConfig.data.resource : this.resource;
    if (this.route.snapshot.params.action && this.route.snapshot.params.action == 'view')
      this.viewOnly = true;
    if (this.route.snapshot.data.showHistory != undefined && this.route.snapshot.data.showHistory == false)
      this.showHistory = false
    this.currentResource = (this.resource != undefined && this.resource.resource != undefined) ? this.resource.resource : (this.route.snapshot.data.resource != undefined ? this.route.snapshot.data.resource : "")
    this.checkCopyRule();
    this.currentData.ehr_view = false;
    this.currentData.scrollToView = false; // config to scroll grid Data into view
    this.currentData.viewerDownload = true
    this.currentData.viewerPrint = true
    this.currentData.bulkAction = false;

    if (JSON.parse(localStorage?.currentUser) != undefined && JSON.parse(localStorage?.currentUser) != "" && JSON.parse(localStorage?.currentUser).user_id && (this.currentResource == 'template_assessment' || this.currentResource == 'template_assessment_op' || this.currentResource == 'template_assessment_final')) {
      this.currentData['show_confidential'] = this.rolePermissionService.checkAccessPermission('confidential_true', this.currentResource)
      this.baseService.get("GET_BY_ID", "id:" + JSON.parse(localStorage?.currentUser).user_id, "account_user", "account-management").subscribe((res) => {
        if (res && res.resource && res.resource[0]) {
          let obj = {
            confidentialDepartmentId: res.resource[0].department_id,
            confidentialDepartment: res.resource[0].department_name
          }
          this.currentDoctor = obj
        } else {
          let obj = {
            confidentialDepartmentId: "",
            confidentialDepartment: ""
          }
          this.currentDoctor = obj
        }
        this.oninitData()
      })
    } else {
      this.oninitData()
    }
  }

  oninitData() {
    if (this.currentResource) {
      this.baseService.getResourceDef(this.currentResource, (resouceDef) => {
        this.onlyEditForDischargePatientList(resouceDef)
        if (resouceDef.config != undefined && resouceDef.config.catalogue_code != undefined) {
          this.archiveConfig.catalogue_code = resouceDef.config.catalogue_code;
        }
        if (resouceDef.config != undefined && resouceDef.config.config_check != undefined) {
          this.checkAdendumHistoryConfig(resouceDef.config.config_check);
        }else{
          this.currentData.addendum_history_show = true;
        }
        if (resouceDef.config != undefined && resouceDef.config.card_field_config_check != undefined && resouceDef.config.card_field_config_check == true) {
          this.checkCardFieldConfig();
        }else{
          this.currentData.card_fields_hide = false;
        }
        this.currentData['fields'] = resouceDef?.list?.fields;
        this.currentData['APIResource'] = resouceDef?.list?.APIresource;
        // Reset pagination state for new resource
        if (this.currentResource && this.paginationRestoredFor !== this.currentResource) {
          this.paginationInitialized = false;
          this.paginationRestoredFor = null;
        }
        // LOAD persisted pagination before first data fetch
        const restoredSelectedIndex = this.loadPaginationState();

        if (this.route.snapshot.queryParams.foreign_id) {
          resouceDef.list.APIresource.datasource['filter'] = "serviceRequestId:" + this.route.snapshot.queryParams.foreign_id
          resouceDef.list?.datasourceConditions.map(x => { return x.datasource.filter = "serviceRequestId:" + this.route.snapshot.queryParams.foreign_id })
        }
        this.currentData['resouceDef'] = resouceDef;
        if (this.currentResource == "ip_diagnostic_report" || this.currentResource == "patient_diagnostic_report") {
          this.configApi()
        }
        if (resouceDef && resouceDef.list && resouceDef.list?.complex_search) {
          this.currentData['resouceDef']['config']['complex_search'] = resouceDef.list?.complex_search
        }
        if (resouceDef?.list?.bulkAction) { // This for bulk action
          this.currentData.bulkAction = resouceDef.list?.bulkAction;
        }

        if (this.currentResource == 'viewUpload_patient_document') {
          this.currentData.bannerJson = {
            "selector": "app-patient-layout",
            "datasource": {
              "application": "patient-registration",
              "resource": "patient",
              "query_id": "GET_BY_ID"
            }
          };
          this.currentData.showBanner = true;
        }
        this.currentData['filterBlock'] = resouceDef.list?.filter;
        this.currentData.document_type = resouceDef && resouceDef.config && resouceDef.config.document_type ? resouceDef.config.document_type : undefined;
        this.currentData['saveInS3'] = resouceDef && resouceDef.config && resouceDef.config.saveInS3 ? resouceDef.config.saveInS3 : false;
        this.currentData.ehr_view_button = resouceDef && resouceDef.config && resouceDef.config.ehr_view ? resouceDef.config.ehr_view : false;
        this.currentData.scrollToView = resouceDef && resouceDef.config && resouceDef.config.scrollToView ? resouceDef.config.scrollToView : false;
        this.currentData.secondary_uhid_default = resouceDef && resouceDef.config && resouceDef.config.secondary_uhid_default ? resouceDef.config.secondary_uhid_default : false;
        this.currentData['cumulativePrintCheckbox'] = resouceDef?.config?.cumulativePrintCheckbox ? resouceDef?.config?.cumulativePrintCheckbox : false;
        this.currentData.ehr_view = resouceDef && resouceDef.config && resouceDef.config.ehr_view_default ? resouceDef.config.ehr_view_default : false;
        this.currentData.secondary_uhid = resouceDef && resouceDef.config && resouceDef.config.secondary_uhid ? resouceDef.config.secondary_uhid : false;
        this.currentData.save_filter = resouceDef && resouceDef.config && resouceDef.config.save_filter ? resouceDef.config.save_filter : false;
        this.currentData.viewerDownloadt = (resouceDef && resouceDef.config && resouceDef.config.viewerDownload == false) ? false : true;
        this.currentData.viewerPrint = (resouceDef && resouceDef.config && resouceDef.config.viewerPrint == false) ? false : true;
        this.currentData.pdf_order_view = false;
        this.baseService.setTitleFromResouceDef(resouceDef, 'LIST');

        if (this.authenticationService.getUserType() == 'patient') {
          let data = { args: "id:" + this.authenticationService.getCurrentUser().user_id }
          this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").toPromise().then(res => {
            if (res) {
              this.currentData['cardData'] = res.resource[0];
              if (this.currentData && this.currentData['cardData'] && this.currentData['cardData']['care_type'] == undefined && this.appService.getUniversalConfig('multi_care_type')) {
                this.currentData['cardData']['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType")
                this.currentData['cardData']['care_type_name'] = this.appService.getDynamicFunctions("getCurrentCareTypeName")
              }
              this.currentData['cardData']['patient_id'] = this.appService.getCurrentUser().user_id
              this.saveUserDepartment();
            }

            this.getHistory(this.currentData['APIResource'].datasource, null, {restoreIndex:restoredSelectedIndex});
          })
          this.currentData.pdf_order_view = true;
        } else {
          if (this.bannerData != undefined) {
            this.currentData['cardData'] = this.bannerData;
            sessionStorage.setItem('currentData', JSON.stringify(this.currentData['cardData']));
            this.saveUserDepartment();
          if (this.currentData['filterBlock'] == undefined || (this.currentData['filterBlock'] != undefined && (this.currentData['filterBlock'].default_filter == undefined || this.currentData['filterBlock'].default_filter == false)))
                this.filterClick(this.search, { pageNo: this.pagination.page_no, restoreIndex: restoredSelectedIndex });
          } else { 
            this.storageService.getSessionStorageData("currentData", (data) => {
              if(data) {
                this.currentData['cardData'] = data;
                // this.currentData['cardData']['patient_id'] = this.appService.getCurrentUser().user_id 
                this.saveUserDepartment();
              } else {
                //when session data is not set
                if (this.bannerJson != undefined && this.bannerJson.datasource != undefined) {
                  if (this.bannerJson.datasource['args'] == undefined && this.route.snapshot.queryParams)
                    this.bannerJson.datasource['args'] = "id:" + this.route.snapshot.queryParams.key;
                  this.baseService.get(this.bannerJson.datasource.query_id, this.bannerJson.datasource['args'], this.bannerJson.datasource.resource, this.bannerJson.datasource.application).toPromise().then(res => {
                    if (res.errCode == -1) {
                      this.alerts.error(res.message);
                    } else {
                      if (res.resource && res.resource.length > 0) {
                        this.currentData['cardData'] = res.resource[0];
                        if (this.currentData && this.currentData['cardData'] && this.currentData['cardData']['care_type'] == undefined && this.appService.getUniversalConfig('multi_care_type')) {
                          this.currentData['cardData']['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType")
                          this.currentData['cardData']['care_type_name'] = this.appService.getDynamicFunctions("getCurrentCareTypeName")
                        }
                        //It doesnt have to call APi again and again if not set
                        sessionStorage.setItem('currentData', JSON.stringify(this.currentData['cardData']));
                        this.saveUserDepartment()
                      }
                    }
                  })
                }
              }
              if (this.currentData['filterBlock'] == undefined || (this.currentData['filterBlock'] != undefined && (this.currentData['filterBlock'].default_filter == undefined || this.currentData['filterBlock'].default_filter == false)))
                this.filterClick(this.search, { pageNo: this.pagination.page_no, restoreIndex: restoredSelectedIndex });
            });
          }
          
        }
        // if (this.currentData && this.currentData && this.currentData.resouceDef && this.currentData.resouceDef.config && this.currentData.resouceDef.config.view_config) {
        //   if (this.appService && this.appService._currentSessionData && (this.appService._currentSessionData.print_engine == true)) {
        //     if (this.currentData.resouceDef.config.view_config) {
        //       let viewConfig = this.currentData.resouceDef.config.view_config;
        //       viewConfig.forEach(res => {
        //         this.setPrintApplication(res);//set application for print url
        //       });
        //     }
        //   }
        // }
        this.config['filterAr'] = []
        if (this.currentData['filterBlock'] != undefined && this.currentData['filterBlock'].quick_filters != undefined)
          this.config['filterAr'] = this.currentData['filterBlock'].quick_filters
        this.config['filterConfig'] = {}
        if (this.config.filterAr && this.config.filterAr.length > 0) {
          this.config.filterAr.forEach(el => {
            if (el.selected != undefined && el.selected) {
              this.default_quick_filter.selected = true
              this.default_quick_filter.data = el
            }
          });
        }
        this.config['save_filter'] = this.currentData.save_filter
        if (this.currentResource != undefined) {
          this.config.saveKey = this.currentResource + "_list_config";
          this.applyTableConfig(() => {
            this.getSavedFilter();
            if(this.config?.localStorageData?.ehr_view != undefined){
              this.currentData.ehr_view = this.config?.localStorageData?.ehr_view;
            }
          });
          if(this.config?.localStorageData?.pdf_order_view){
            this.currentData.pdf_order_view = true
          }
        }
      });
    } else if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.showImageViewer) {
      this.currentData = {};
      this.showImageView = true;
      if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data['read_scope_level'] != undefined && this.dialogConfig.data['read_scope_level'] == 'account') {
        this.currentData.ehr_view = true;
      }
      this.onClickSideList(this.dialogConfig.data.config);
    }
    this.getPinConfig();
    this.getCurrentDepartment();
  }

  pdfOrderView(e){
    this.currentData.pdf_order_view = !this.currentData.pdf_order_view
    if(this.config.localStorageData){
      this.config.localStorageData['pdf_order_view'] = this.currentData.pdf_order_view
      this.preferenceService.saveTableConfigData(this.config.saveKey, this.config.localStorageData);
    }
    this.currentData['pdfOrderViewEvent'] = true
    this.getHistory();
  }

  getCurrentDepartment(){
    let id = this.authenticationService.getCurrentUser().user_id;
    if(this.authenticationService.getCurrentUser().role_type.toLowerCase() == 'practitioner'){
      let payload = {}
      let filter = `practitioner_id:${id}`
      payload['filter'] = filter
      this.baseService.getData(payload, '', "practitioner_facility_details", "facility-management", "GET_PAGE").subscribe(data => {
        if (data.errCode == 0 && data?.resource && Array.isArray(data?.resource) && data?.resource?.length > 0) {
          this.currentData.dept_id = data.resource[0].department_id;
        }
      })
    }else{
      this.baseService.getById(id, "account_user", "account-management").subscribe(data => {
        if (data) {
          this.currentData.dept_id = data.department_id;
        }
      })
    }
  }

  getPinConfig(){
    //Gets config for pin/password required or not
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:pin_required", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.includes('e_prescription')) {
          this.isPinRequired = true;
        } else {
          this.isPinRequired = false;
        }
      } else {
        this.isPinRequired = false;
      }
    });
  }

  checkAdendumHistoryConfig(configure){
    this.baseService.get(configure.query_id, configure.args, configure.resource, configure.application).subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "no"){
          this.currentData.addendum_history_show = true;
        }else{
          this.currentData.addendum_history_show = false;
        }
      }else if (data.errCode == 0) {
        this.currentData.addendum_history_show = true;
      }else{
        this.currentData.addendum_history_show = false;
      }
    });
  }

  checkCardFieldConfig(){
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:Hide_modifyDate_ModifyBy_version_and_addendum", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "yes"){
          this.currentData.card_fields_hide = true;
        }else{
          this.currentData.card_fields_hide = false;
        }
      }else if (data.errCode == 0) {
        this.currentData.card_fields_hide = false;
      }else{
        this.currentData.card_fields_hide = false;
      }
    });
  }

  checkCatalagueConfigExists(config, cb) {
    this.preferenceService.checkCatalagueConfigExists(config, (respObj) => {
      if (respObj.loadArchiveConfig != undefined) {
        this.archiveConfig.list = respObj.loadArchiveConfig.list;
      }
      this.archiveConfig.loaded = true
      cb()
    })
  }
  showArchivePolicy() {
    if (this.archiveConfig) {
      if (this.archiveConfig.catalogue_code != undefined) {
        this.checkCatalagueConfigExists({ archiveConfig: this.archiveConfig }, (resourceDef) => {
          this.toggleArchivePolicy();
        })
      } else {
        this.toggleArchivePolicy();
      }
    }
  }

  toggleArchivePolicy() {
    if (this.archiveConfig.list != undefined && this.archiveConfig.list.length > 0) {
      if (this.archiveConfig.open == undefined) {
        this.archiveConfig.open = true;
      } else {
        this.archiveConfig.open = !this.archiveConfig.open;
      }
    }
  }
  setArchivePolicy(archiveConfig) {
    this.archiveConfig.selected = archiveConfig;
    this.toggleArchivePolicy();
    this.hitApiUsingFilter(this.filter.filter)
  }

  applyArchivePoicy() {
    var argsArchive: any = false;
    if (this.archiveConfig.list != undefined && this.archiveConfig.selected != undefined) {
      argsArchive = "archive_policy:" + this.archiveConfig["selected"]["id"];
      if (this.archiveConfig["selected"]["db_type"] != undefined) {
        argsArchive += ",archive_db_type:" + this.archiveConfig["selected"]["db_type"]
      }
      if (this.archiveConfig["selected"]["collection"] != undefined) {
        argsArchive += ",archive_collection:" + this.archiveConfig["selected"]["collection"]
      }
      return argsArchive;
    }
  }
  configApi() {
    //Gets config for pin/password required or not
    this.baseService.get("GET_ALL_FACILITY_CONFIGS", "module_code:diagnostic,config_code:diagnostic_103", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        const keysToKeep = ["facility_id", "config_value"];
        const filteredData = data.resource.map(obj => {
        const newObj: any = {};
        keysToKeep.forEach(key => {
            if (key in obj) {
              newObj[key] = obj[key];
            }
          });
          return newObj;
        });
        this.pacs_integration = filteredData;
        // if (data.resource[0].config_value == 'enabled_with_dynamic_url' || data.resource[0].config_value == 'enabled_with_static_url') {
        //   this.pacs_integration = true
        // }
      } else {
      }
    });
  }

  nextImage() {
    if (this.checkNextButton() == null) {
      this.activeValue = this.pagination.selected_index + 1;
      this.ngZone.run(() => {
        this.hitSecondaryDataSource(this.currentData['list'][this.pagination.selected_index + 1], this.pagination.selected_index + 1, true)
      })
    }
  }

  /** Toggle  clicked item's expanded and collapse  */
  expandCard(item: any, index: number, event: Event) {
      const willExpand = !(item && item._expanded);
      this.currentData.list.forEach((it: any) => {
        it._expanded = false;
      });
      if (item) {
        item._expanded = willExpand;
      }
  }

  prevImage() {
    if (this.checkPreviousButton() == null) {
      this.activeValue = this.pagination.selected_index - 1;
      this.ngZone.run(() => {
        this.hitSecondaryDataSource(this.currentData['list'][this.pagination.selected_index - 1], this.pagination.selected_index - 1, true)
      })
    }
  }

  manageFilter() {
    if (this.config.saveKey == undefined) {
      console.error("resource not found");
    } else {
      this.getSavedFilter((filterData) => {
        let popobj = { data: { self: this, data: filterData }, title: 'Manage Your Filters', size: DialogModalSize.Sm };
        this.dialogService.open(ManageFilterComponent, popobj).afterClosed.subscribe(
          res => {
            this.getSavedFilter();
            this.resetFilter('');
          });

      });
    }
  }

  applyTableConfig(callback) {
    this.getTableConfig((data) => {
      callback();
    })
  }
  getTableConfig(callback) {
    var key = this.config.saveKey;
    this.preferenceService.getUserPreferenceConfig(key, (data) => {
      this.config.localStorageData = data;
      callback(data);
    });
  }
  getSavedFilter(callback: any = false) {
    console.log("Config", this.config);
    this.getTableConfig((data) => {
      console.log("Quick Filters ", this.currentData['filterBlock']);
      if (this.currentData['filterBlock'] && this.currentData['filterBlock'].quick_filters && data['filter__'] != undefined) {
        this.currentData['filterBlock'].quick_filters.forEach(function (item) {
          item['type'] = 'quick';
        });
        this.config.filterAr = this.currentData['filterBlock'].quick_filters.concat(data['filter__']);
        if (callback) {
          callback(this.config.filterAr);
        }
      } else if (this.currentData['filterBlock'] && this.currentData['filterBlock'].quick_filters && data['filter__'] == undefined) {
        this.currentData['filterBlock'].quick_filters.forEach(function (item) {
          item['type'] = 'quick';
        });
        this.config.filterAr = this.currentData['filterBlock'].quick_filters;
        if (callback) {
          callback(this.config.filterAr);
        }
      } else
        if (data['filter__'] != undefined && data['filter__'].length) {
          this.config.filterAr = data['filter__'];
          if (callback) {
            callback(data['filter__']);
          }
        } else {
          this.config.filterAr = [];
          if (callback) {
            callback([]);
          }
        }
    });
  }

  /**
   * Main data loading method that fetches list data from the server
   * Handles pagination restoration and maintains selected item state
   * @param datasource - API datasource configuration
   * @param callback - optional callback function
   * @param restoreIndex - specific index to restore after data load
   */
  getHistory(datasource?, callback = null, obj:{restoreIndex?: number | null} = {restoreIndex: null}) {
    this.loader.showSpinner();
    // AUTO-RESTORE: Last chance to restore pagination before data load
    if (obj?.restoreIndex === null || obj?.restoreIndex === undefined) {
      this.ensurePaginationRestored();
    }
    /** enable add after end consultation for view emr **/
    if (this.route.snapshot.params.action && this.route.snapshot.params.action == 'view' && this.currentData['cardData'] && (this.currentData['cardData'].patientType == 'OP' || this.route.snapshot.params.key == 'emr_phc_patient') && (this.currentResource == 'template_assessment' || this.currentResource == 'template_assessment_final' || this.currentResource == 'template_assessment_op' || this.currentResource == 'certificate') && (this.currentData['cardData'].stage == 'Prescription Sent' || this.currentData['cardData'].stage == 'Completed')) {
      this.baseService.get("GET_CONFIG", "module_code:emr,config_code:fill_template_post_end_consultation", "facility_config_mapping", "facility-management").subscribe(data => {
        if (data.errCode == 0 && data.resource && data.resource.length > 0) {
          if (data.resource[0].config_value != undefined && data.resource[0].config_value == "yes")
            this.viewOnly = false;
        }
      });
    }
    /***********************/
    var args = '';
    var filter = '';
    var search = '';
    if (datasource && datasource.search)
      search = datasource.search
    if (datasource == undefined) {
      datasource = this.checkGetAPI();
    }
    if (datasource) {
      if (datasource.args != undefined && datasource.args.indexOf('!!!') != -1) {
        // if (this.currentData['cardData'])
        //   this.currentData['cardData']['orderingDepartmentId'] = this.currentData['cardData']['patientType'] == 'OP' ? this.currentData['cardData']['department_id'] : this.currentData['cardData']['treating_department_id'];//added for confidential temp
        args = this.baseService.buildDyanamicStr(datasource.args, { data: this.currentData['cardData'] })
      }
      else
        args = datasource.args
      //need to remove if we discard view screen
      if (datasource.filter != undefined && datasource.filter.indexOf('!!!') != -1) {
        filter = this.baseService.buildDyanamicStr(datasource.filter, { data: this.currentData['cardData'] })
      }
      else
        filter = datasource.filter ? datasource.filter : ''
      var data = {
        args: args,
        search: (search != undefined && search != "") ? search : this.search,
        page_no: this.pagination.page_no,
        page_size: this.pagination.page_size,
        filter: filter + (filter && this.filter && this.filter.filter ? "," : '') + this.filter.filter
      }
      if (datasource.order_by && this.currentResource == 'progress_note') {
        data['order_by'] = datasource.order_by;
      }
      if (typeof this.complex_search_value == 'object') {
        data['search_columns'] = this.complex_search_value['key']
        data['searchColumns'] = this.complex_search_value['key']
      }
      if (this.currentData.secondary_uhid_default) {
        data['args'] += "," + "secondary_uhid:true"
      }
      if (this.currentData['show_confidential']) {
        data['args'] += "," + "show_all_confidential:true"
      } else {
        data['args'] += "," + "show_all_confidential:false"
      }
      if (this.currentData?.['cardData']?.confidentialDepartmentId) {
        data['args'] += ",confidentialDepartmentId:" + this.currentData['cardData'].confidentialDepartmentId
      }
      if (this.currentData.ehr_view)
        data['read_scope_level'] = 'account';
      else if (data['read_scope_level'] != undefined)
        delete data['read_scope_level'];

      var argsArchive = this.applyArchivePoicy();
      if (argsArchive && data['args'] != undefined) {
        data['args'] = data['args'] + "," + argsArchive
      }
      if (this.router.url.indexOf('emrDiagnosticDesign') > -1) {        // for diagnostic profile tests wise grid view
        datasource.query_id = "GET_PAGE";
        data.filter = "serviceRequestId:!!!serviceRequestId!!!,uhId:!!!uhId!!!,orderId:!!!orderId!!!,containsBasicInfo:true,status:Final";
        data.filter = this.baseService.buildDyanamicStr(data.filter, { data: this.currentData['cardData'] });
      }

      if ((this.currentResource == 'template_assessment' || this.currentResource == 'progress_note' || this.currentResource == 'initial_assessment_final' || this.currentResource == 'discharge_summary' || this.currentResource == 'package_note_emr' || this.currentResource == 'surgery_note_emr' || this.currentResource == 'template_assessment_final' || this.currentResource == 'pac_template' || this.currentResource == 'certificate' || this.currentResource == 'template_assessment_procedure') && this.currentData['filter_based'] != 'all') {
        if (this.currentData['filter_based'] != undefined && this.currentData['filter_based'] != '') {
          data['args'] += (data['args'] != '' ? ',' : '') + this.currentData['filter_based'];
        }
      }

      this.baseService.getData(data, "", datasource.resource, datasource.application, datasource.query_id || datasource.queryId).subscribe(res => {
        if (callback && this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.getter_list_key != undefined) {
          callback(res);
        } else {
          this.loader.hideSpinner();
          if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.decorator != undefined) {
            if (!this.currentData.decorator || (this.currentData.decorator && this.currentData.decorator.className != undefined && this.currentData.decorator.className != this.currentData['resouceDef'].config.decorator))
              this.currentData.decorator = this.baseService.initDecorator(this.currentData['resouceDef'].config.decorator, this.route, this.injector);
          }
          if (this.currentData.decorator.beforeSaveList) {
            this.currentData.decorator.beforeSaveList(this.baseService, res.resource, (cb) => {
              res.resource = cb;
              this.currentData['list'] = cb
              if (cb.length > 0 && this.currentData['list']) {
                // this.pagination.selected_index = 0;
                // this.activeValue = 0;
                this.currentData['list'].map((x, index) => x['selected_index'] = index);
              }
            })
          } else
            this.currentData['list'] = res.resource;
          if (res.resource != undefined && res.resource.length > 0 && this.currentData['list']) {
            this.reHydrateSelectedItemsForPrint();
            let finalIndex: number;
        
            // Improved index selection logic with multiple fallback options
            if (typeof obj.restoreIndex === 'number' && obj.restoreIndex >= 0 && obj.restoreIndex < res.resource.length) {
              finalIndex = obj.restoreIndex;
              console.log(`Using provided restoreIndex: ${finalIndex}`);
            } else if (this.pagination.selected_index >= 0 && this.pagination.selected_index < res.resource.length) {
              // Keep previously set (possibly restored) index
              finalIndex = this.pagination.selected_index;
              console.log(`Using current pagination index: ${finalIndex}`);
            } else {
              finalIndex = 0;
              console.log(`Defaulting to index: ${finalIndex}`);
            }

            // Update pagination state with validated index
            this.pagination.selected_index = finalIndex;
            this.activeValue = finalIndex;
            this.currentData['list'].map((x, index) => x['selected_index'] = index);
          }
          // Persist pagination state after list and selection are resolved
          this.savePaginationState();
          console.log(this.currentData['list'], "this.currentData['list']")
          /** 128486 for default open aside form **/
          if (!this.viewOnly && this.currentData && this.currentData['list'] && this.currentData['list'].length == 0 && this.checkExpressionForAdd() && this.currentData.cardData && this.currentData.decorator && this.currentData.decorator.onTabClick && !this.closeAsideOnCloseBtn) {
            this.currentData.decorator.onTabClick(this.currentData.cardData, this, (cb) => {
              if (cb) {
                this.setAsideView();
              }
            });
          }
          /*******/
          this.currentData['count'] = res.count;
          this.checkExpandableFeatureEnabled()
          if (this.route.snapshot.queryParams.activePrescriptionId != undefined && res.resource && res.resource.length > 0 && !this.utilService.isMobile()) {
            let activeValueindex = res.resource.indexOf(res.resource.find(x => x.id == this.route.snapshot.queryParams.activePrescriptionId));
            this.activeValue = (activeValueindex == undefined ? 0 : activeValueindex);
            this.hitSecondaryDataSource(res.resource[this.activeValue])
          }

          if (res.resource && res.resource.length > 0 && !this.utilService.isMobile()) {
            // Use the selected index instead of forcing first element
            const selIdx = this.pagination.selected_index || 0;
            console.log(`Hitting secondary data source with index: ${selIdx}`);
            this.hitSecondaryDataSource(res.resource[selIdx], selIdx);
          }
          else {
            this.currentData['selectedList'] = undefined
          }
        }
      }, err => {
        this.loader.hideSpinner();
        console.error("Api gives Error", err);
        if (callback)
          callback(false);
      });
    } else {
      this.loader.hideSpinner();
    }
  }

  getFilterBasedData(filter) {
    this.currentData.list = [];
    this.currentData['filter_based'] = filter;
    this.filter.filter = this.filter.pseudoFilter;//clear filter in switch radio button
    this.getHistory();
  }
  toggleAutoRefresh() {
    if (this.currentData.ehr_view)
      this.currentData.ehr_view = false;
    else
      this.currentData.ehr_view = true;
    this.currentData.list = [];
    this.filter.filter = this.filter.pseudoFilter;
    this.config.localStorageData.ehr_view = this.currentData.ehr_view;
    if(this.currentData['resouceDef']?.config?.ehr_view_preference)
      this.saveTableConfigData(this.config.localStorageData);
    this.getHistory();
  }
  secondaryUhidBtn() {
    if (this.currentData.secondary_uhid_default)
      this.currentData.secondary_uhid_default = false;
    else
      this.currentData.secondary_uhid_default = true;

    this.filter.filter = this.filter.pseudoFilter;
    this.getHistory();
  }
  onClickSideList(list, show?, versionCheck?) {
    if (this.getAmountConfigValue) {
      this.getAmountConfigValue = false;
      this.GetAmountConfig(list);
    }
    //setting the version control info 
    if (this.currentData && this.currentData.resouceDef && this.currentData.resouceDef.config != undefined && this.currentData.resouceDef.config.definalize != undefined && !versionCheck && list.partOf != undefined) {
      this.currentData['hideDropdown'] = false;
      this.currentData.versionVal = '';
      this.setVersionControl(list);
    }
    if (!list.partOf) {
      this.currentData['hideDropdown'] = true;
    }

    this.currentData['selectedList'] = undefined
    this.currentData.show = this.utilService.isMobile() && !show && this.dialogConfig?.data?.inPopup != true ? false : true;
    let item = list;
    if (this.currentData && this.currentData['resouceDef'] && this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.view_config != undefined && this.currentData['resouceDef'].config.view_config.length > 0) {
      var config = this.currentData['resouceDef'].config.view_config.filter(data => {
        let pdfOrderView = data.pdfOrderView
        if (this.currentData.pdf_order_view) { } else { pdfOrderView = true }
        if (data.expression != undefined) {
          if (eval(data.expression))
            return data;
        } else if (pdfOrderView != undefined) {
          if (eval(pdfOrderView))
            return data;
        } else {
          return data;
        }
      })
    }
    this.currentData['selectedList'] = list;
    if (config && config.length > 0) {
      this.currentData['selectedList']['view_selected_config'] = config[0];
      let key = this.currentData['selectedList']['view_selected_config'].dynamic_key != undefined ?
        eval(this.currentData['selectedList']['view_selected_config'].dynamic_key) :
        this.currentData['selectedList']['view_selected_config'].key != undefined ?
          this.currentData['selectedList']['view_selected_config'].key : 'documentId';

      if (this.currentData.selectedList['view_selected_config']['type'] == 'image' && (this.currentData['selectedList']['view_selected_config'].expression == undefined || eval(this.currentData['selectedList']['view_selected_config'].expression))) {
        this.getGridCardFields(this.currentData.selectedList['view_selected_config'].gridSource);
        if (typeof (list[key]) == 'string') {
          this.currentData['selectedList']['documentIds'] = [];
          this.currentData['selectedList']['documentIds'].push({ "documentId": list[key] });
        } else if (config[0].viewKey != undefined && typeof (eval(config[0].viewKey)) == 'string') {
          this.currentData['selectedList']['documentIds'] = [];
          this.currentData['selectedList']['documentIds'].push({ "documentId": eval(config[0].viewKey) });
        }
      } else if (this.currentData.selectedList['view_selected_config']['type'] == 'pdf' && this.currentData.selectedList['view_selected_config'].url != undefined) {
        this.loader.showSpinner();
        if (list.s3 == undefined && list.document_id != undefined && list.document_id && list.document_id != '') {
          let url = this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + list.document_id + '&application=dms';
          this.currentData.selectedList.url = undefined;
          this.baseService.getFileByUrl(url, false).subscribe((res: any) => {
            console.log("Url is ", res);
            this.currentData.selectedList.url = URL.createObjectURL(res);
            this.currentData.selectedList.urlBlob = res;
            this.currentData.selectedList.urlFileType = this.baseService.getExtensionbyMimeType(res.type);
            this.currentData.selectedList.urlFileName = "Doc_" + list.prescriptionNo;
          });
        }
        // Add by Sanjay for PrintEngine: resource is prescription_history pdf url should contain application_name
        else if (this.currentData.selectedList['view_selected_config'].reportTemplateId != undefined && this.currentData.selectedList['view_selected_config'].reportTemplateId != "") {
          var reportTemplateId = this.currentData.selectedList['view_selected_config'].reportTemplateId;
          // var app_name = this.baseService.printApplicationName(reportTemplateId);
          var file_url = this.currentData.selectedList['view_selected_config'].url;
          if (file_url.indexOf('!!!application_name!!!') > -1) {
            file_url = file_url.replace('!!!application_name!!!', 'printengine');
          }
          this.currentData.selectedList['view_selected_config'].url = file_url;
        }
        if (list.s3 != undefined && list.s3 && list.document_id != undefined && list.document_id != '') {
          this.currentData.selectedList.view_selected_config = {};
          this.currentData.selectedList.view_selected_config.type = 'pdf';
          let url = this.baseService.getApiEndpoint("dms") + this.currentData.document_type + '/image-response-entity?path=' + list.document_id + '&application=dms';
          this.currentData.selectedList.url = undefined;
          this.baseService.getFileByUrl(url, false).subscribe((res: any) => {
            if (res) {
              console.log("Url is ", res);
              this.currentData.selectedList.url = URL.createObjectURL(res);
              this.currentData.selectedList.urlBlob = res;
              this.currentData.selectedList['view_selected_config'] = {};
              this.currentData.selectedList['view_selected_config']['type'] = 'pdf';
              this.currentData.selectedList.urlFileType = 'pdf';
              this.currentData.selectedList.urlFileName = "Doc_" + list.id + '.' + this.currentData.selectedList.urlFileType;
            }
          });
        } else if (list.document_id == undefined || list.document_id == '' || (!list.s3 && list.document_id != '')) {
          // var obj = this.currentData['selectedList']['view_selected_config']
          // this.setPrintApplication(obj);//set application for print url
          this.urlMaker(this.currentData.selectedList['view_selected_config'].url, (url) => {
            this.currentData.selectedList.url = undefined;
            this.makeImageFromUrl(url);
          });
        }

      } else if (this.currentData.selectedList['view_selected_config']['type'] == 'form' && this.currentData.selectedList['view_selected_config'].formsource != undefined) {
        this.viewForm();
      }
      else if (this.currentData.selectedList['view_selected_config']['type'] == 'grid' && this.currentData.selectedList['view_selected_config'].gridSource != undefined) {
        this.getGridCardFields(this.currentData.selectedList['view_selected_config'].gridSource)
      }
    } else if (list.view_config) {
      if (list.view_config[0]['type'] == 'pdf' && list.view_config[0].url != undefined) {
        this.loader.showSpinner();
        let getUrl = true;
        if (list.view_config[0].expression != undefined) {
          getUrl = this.checkUrlToExecute(list.item, list.view_config[0].expression);
        }
        if (getUrl) {
          this.urlMaker(list.view_config[0].url, (url) => {
            // this.currentData.selectedList.url = url;
            this.makeImageFromUrl(url);
            this.currentData.selectedList.view_selected_config = {};
            this.currentData.selectedList.view_selected_config.type = list.view_config[0]['type'];
            this.currentData.show = true;
          });
        } else {
          this.currentData.selectedList = undefined;
          this.currentData.list = [];
          this.loader.hideSpinner();
        }
      } else if (list.view_config[0]['type'] == 'GRID' && list.view_config[0].datasource != undefined) {
        if (list.item == undefined)
          this.noObservationFound = true
        else
          list?.resource?.forEach(element => {
            element['showPrint'] = item['showPrint']
            if(element.tests != undefined && element.tests.length > 0){
              element.tests.forEach(el => {
                  el['showPrint'] = item['showPrint']
              });
            }
          });
          this.currentData.gridCardData = { "resource": Array.isArray(list.item) ? list.item : [list.item] };
        this.currentData.selectedList.view_selected_config = {};
        this.currentData.selectedList.view_selected_config.type = "grid";
        this.getGridCardFields(list.view_config[0].datasource.gridSource);
      }
    } else
      this.noObservationFound = true
  }
  GetAmountConfig(list) {
    // let args = `op_no:${op_no},uhId:${uhId},serviceRequestId:${serviceRequestId},encounter_id:${encounter_id}`;
    let args = "";
    if (list.op_no != undefined && list.op_no != "") {
      args = `op_no:${list.op_no},uhId:${list.uhId},serviceRequestId:${list.serviceRequestId}`;
    } else if (list.encounter_id != undefined && list.encounter_id != "") {
      args = `uhId:${list.uhId},serviceRequestId:${list.serviceRequestId},encounter_id:${list.encounter_id}`;
    }
    this.noObservationFound = true
    this.baseService.get("check-due-pending", args, "observation", "diagnostic").subscribe((result: any) => {
      console.log("inside GetAmountConfig", this.noObservationFound);
      if (result != undefined && result && result.message != 'Success') { // value == true // 
        this.alerts.error("You can not download and view the report as bill is in due stage.");
        this.noObservationFound = true
      } else {
        this.noObservationFound = false
      }
    })
  }

  checkNextPageDisbaled() {

  }

  // setPrintApplication(obj) {
  //   if (obj && obj.template) {
  //     var template = obj.template;
  //     if (this.appService.printEngineTemplate && this.appService.printEngineTemplate.length > 0) {
  //       this.templateChecked = this.appService.printEngineTemplate.some(x => x.id === template);
  //       if (obj && obj.newPrint && this.templateChecked) {
  //         this.newPrintEnable = obj.newPrint;
  //         var app_name = this.baseService.printApplicationName(template);
  //         let url = obj.url;
  //         var replaceApplication = /report-management/gi;
  //         var finalURL = url.replace(replaceApplication, app_name);
  //         obj.url = finalURL;
  //       }
  //     }
  //   }
  // }
  checkUrlToExecute(item, expression) {
    if (expression) {
      return eval(expression);
    } else {
      return true;
    }
  }

  visibleforTat(tat) {
    return (tat && tat.filter(x => x.visible == true).length > 0) ? true : false;
  }

  urlMaker(confUrl, cb) {
    let url = location.origin + confUrl;
    if (url.indexOf('!!!application_name!!!') != -1)
      url = url.replace('!!!application_name!!!', 'printengine');
    if (url.indexOf('!!!') != -1)
      url = this.baseService.buildDyanamicStr(url, { data: this.currentData['selectedList'] })
    if (this.currentData.ehr_view)
      url = url + "&read_scope_level=account";
    cb(url);
  }
  makeImageFromUrl(url) {
    let st_data = JSON.parse(JSON.stringify(this.currentData.selectedList));
    this.baseService.getFileByUrl(url, false).subscribe(res => {
      st_data.url = URL.createObjectURL(res);
      st_data.urlBlob = res;
      st_data.urlFileType = this.baseService.getExtensionbyMimeType(res.type);
      let f_name;
      if (st_data.prescriptionNo != undefined) {
        f_name = "Doc_" + st_data.prescriptionNo;
      } else {
        f_name = "Doc_" + this.baseService.generateID(4);
      }
      f_name += st_data.urlFileType;
      if (st_data.status == 'final' && this.currentData['saveInS3']) {
        // let args = "id:"+ (st_data.id? st_data.id : st_data.observation_id);
        // this.getData('GET_OBSERVATION_DATA_BY_ID', args, 'observation', 'diagnostic', '', (data1) => {
        //   if(data1){
        //     let data = { ...data1[0], ...{ uniqueFile: true, noSave: true, saveJson: false, s3_time: moment(data1.g_creation_time).format("YYYY-MM-DD") } };
        //     if(data.id || data.observation_id){
        //       f_name = "Doc_" + (data.id ? data.id : data.observation_id);
        let data = { ...st_data, ...{ uniqueFile: true, noSave: true, saveJson: false, s3_time: moment(st_data.g_creation_time).format("YYYY-MM-DD") } };
        if (st_data.id || st_data.observation_id) {
          f_name = "Doc_" + (st_data.id ? st_data.id : st_data.observation_id);
          f_name += st_data.urlFileType;
        }
        this.printService.uploadDownloadedData(res, f_name, this.currentData.document_type, data, this.authenticationService.getCurrentUser().user_id, "application/pdf", (res) => {
          if (res && res.resource && res.resource.length > 0 && (res.resource[0].path != undefined || res.resource[0].document_id != undefined)) {
            if (this.currentData.selectedList) {
              this.currentData.selectedList.view_selected_config = {};
              this.currentData.selectedList.view_selected_config.type = 'pdf';
              // this.currentData.selectedList.url = res.resource[0].path;
            }
            this.setS3variableinMongo(st_data.id, true, res.resource[0].document_id);
          } else {
            if (this.currentData.selectedList) {
              this.currentData.selectedList.urlFileType = st_data.urlFileType;
              this.currentData.selectedList.urlBlob = st_data.urlBlob;
              this.currentData.selectedList.url = st_data.url;
              this.currentData.selectedList.urlFileName = f_name;
            }
            this.setS3variableinMongo(st_data.id, false);
            //     }
            //   });
            // }else{
            //   this.currentData.selectedList.urlFileType = st_data.urlFileType;
            //   this.currentData.selectedList.urlBlob = st_data.urlBlob;
            //   this.currentData.selectedList.url = st_data.url;
            //   this.currentData.selectedList.urlFileName = f_name;
          }
        });
      } else {
        this.currentData.selectedList = st_data;
        this.currentData.selectedList.view_selected_config = {};
        this.currentData.selectedList.view_selected_config.type = 'pdf';
        this.currentData.selectedList.urlFileType = st_data.urlFileType;
        this.currentData.selectedList.urlBlob = st_data.urlBlob;
        this.currentData.selectedList.url = st_data.url;
        this.currentData.selectedList.urlFileName = f_name;
      }
      this.currentData.selectedList.urlFileName += st_data.urlFileType;
      this.loader.hideSpinner();
    })
  }
  setS3variableinMongo(id, s3, document_id?) {
    let obj = { id: id, s3: s3 };
    if (document_id) {
      obj['document_id'] = document_id;
    }
    let app = "diagnostic";
    let resource = "observation";
    if (this.currentData['APIResource'] && this.currentData['APIResource'].datasource) {
      app = this.currentData['APIResource'].datasource.application;
      resource = this.currentData['APIResource'].datasource.resource;
    }
    this.baseService.action(obj, "saveS3Status", app, resource).subscribe(res => {
      if (res.errCode == 0) {
      }
      else
        this.alerts.error(res.message)
    })
  }
  viewForm() {
    this.loader.showSpinner();
    this.currentData['formViewData'] = undefined;
    var formsource: any = JSON.parse(JSON.stringify(this.currentData.selectedList['view_selected_config'].formsource));
    var item = this.currentData['selectedList']
    if (this.currentData.selectedList['view_selected_config'].expression == undefined ||
      eval(this.currentData.selectedList['view_selected_config'].expression))
      this.fetchFormTemplateApi(formsource)
  }

  fetchFormTemplateApi(formsource) {
    if (formsource.args != undefined && formsource.args.indexOf('!!!') != -1) {
      formsource.args = this.baseService.buildDyanamicStr(formsource.args, { data: this.currentData['selectedList'] })
    }
    this.baseService.getData({ args: formsource.args }, "", formsource.resource, formsource.application, formsource.queryId).subscribe(res => {
      this.currentData['formViewData'] = res.resource[0];
      this.loader.hideSpinner();
    }, err => {
      this.loader.hideSpinner();
      console.error("Api gives Error", err);
    });
  }

  goPrev() {
    if (this.pagination['page_no'] && this.pagination['page_no'] != 0 && this.currentData['count'] > this.pagination['page_no']) {
      this.pagination['page_no'] = this.pagination['page_no'] - 1;
      if (this.default_quick_filter && this.default_quick_filter.executed) {
        this.filter.filter = this.filter.filter + "," + this.default_quick_filter.executed;
      } else {
        this.filter.filter = this.filter.pseudoFilter == '' ? this.filter.filter : this.filter.pseudoFilter;
      }
      if (this.filter.filter != '')
        this.filter.filter = this.filterService.removeDuplicateKeysFromString({ "filter": this.filter.filter });
      return this.getHistory();
    }
  }

  goNext() {
    this.pagination['page_no'] = this.pagination['page_no'] + 1;
    if (this.default_quick_filter && this.default_quick_filter.executed) {
      this.filter.filter = this.filter.filter + "," + this.default_quick_filter.executed;
    } else {
      this.filter.filter = this.filter.pseudoFilter == '' ? this.filter.filter : this.filter.pseudoFilter;
    }
    if (this.filter.filter != '')
      this.filter.filter = this.filterService.removeDuplicateKeysFromString({ "filter": this.filter.filter });
    return this.getHistory();
  }

  getClassToEnableDisableIcon() { // setting goNext icon disabled if datasource reaches maximum limit
    if (this.currentData['count'] > 0) {
      var lastPage = this.currentData['count'] / this.pagination.page_size;
      if (lastPage > this.pagination['page_no'] + 1) {
        return null;
      } else {
        return true;
      }
    }
  }

  fitUnfitPopup(data, decorator) {
    if (data.result['flag_value']) {
      delete data.result['marked_from_date']
      delete data.result['marked_to_date']
      delete data.result['marked_for_days']
    }
    var obj = {
      ...data.result,
      ...this.currentData.cardData
    }
    this.baseService.action(obj, "FIT_REGISTRATION", "adt", "fit_unfit_certificate").subscribe(res => {
      if (res.errCode == 0) {
        var args = 'uhId:' + this.currentData.cardData.uhId + ',patientType:' + this.currentData.cardData.patientType + ',encounter_id:' + this.currentData.cardData.encounter_id
        this.baseService.get("GET_FIT_UNFIT_CERTIFICATE_DATA_USING_UHID", args, 'fit_unfit_certificate', 'adt').subscribe(res => {
          if (res && res.resource != undefined && res.resource.length > 0) {
            data.result['certificate_no'] = res.resource[0].certificate_no
            this.saveData(data, decorator);
          } else {
            this.alerts.error(res.message)
          }
        })
      }
      else
        this.alerts.error(res.message)
    })


    // if (this.currentData.cardData && this.currentData.cardData.patientType == 'OP') {
    //   if (this.currentData.cardData['currentTreatingDoctor'] == undefined && this.currentData.cardData.treatingDoctor)
    //     this.currentData.cardData['currentTreatingDoctor'] = this.currentData.cardData.treatingDoctor;
    //   if (this.currentData.cardData['currentTreatingDoctorId'] == undefined && this.currentData.cardData.treatingDoctorId)
    //     this.currentData.cardData['currentTreatingDoctorId'] = this.currentData.cardData.treatingDoctorId;
    //   if (this.currentData.cardData['currentTreatingDoctorSpeciality'] == undefined && this.currentData.cardData.speciality_name)
    //     this.currentData.cardData['currentTreatingDoctorSpeciality'] = this.currentData.cardData.speciality_name;
    //   if (this.currentData.cardData['currentTreatingDoctorSpecialityId'] == undefined && this.currentData.cardData.speciality_id)
    //     this.currentData.cardData['currentTreatingDoctorSpecialityId'] = this.currentData.cardData.speciality_id;
    // }
    // let obj = {
    //   "action": this.currentData['resouceDef'].onAdd,
    //   "val": this.currentData.cardData
    // }
    // this.smartModalService.open(DynamicPopUpComponent, obj, obj.action.title, ModalSize.Md).subscribe(res => {
    //   if (res) {
    //     //open aside form after close popup
    //     this.openAsideForm(componentConfig, size, display_name)
    //   }
    // },
    //   err => {
    //     console.log("error in getting data :: ", err);
    //   });
  }

  ancRegistrationFlow(componentConfig, size, display_name, action) {
    var ancRegistered = false // to check if ANC flag already available
    if (this.currentData.cardData) {
      var data = { "filter": 'uhId:' + this.currentData.cardData.uhId }
      var b = this.currentData.cardData.patient_age.split(',')
      var patientAge = b[0].split(" ")
    }
    this.baseService.getData(data, '', "anc_registration", "adt", "GET_ALL_ANC_REGISTRATION").subscribe(res => {
      if (res && res.resource != undefined && res.resource.length > 0 && res.resource[0].anc_status == true) {
        if (componentConfig && componentConfig.inputs && componentConfig.inputs.data && componentConfig.inputs.data.actionType && componentConfig.inputs.data.actionType.action_name == 'ADD')
          this.alerts.error("ANC Registration already done")
        this.openAsideForm(componentConfig, size, display_name, action)
      }
      else {
        if (this.currentData.cardData != undefined && this.currentData.cardData.patient_gender != undefined && this.currentData.cardData.patient_gender.toLowerCase() == "female" && patientAge[1] == 'Y' && (parseInt(patientAge[0]) > 12 || (parseInt(patientAge[0]) == 12) && b.length > 1)) {
          var dialogRef = this.asideBarService.baseService.modalService.confirmCustomBtn("ANC Acknowledge", "Are you sure you want to do ANC registration?", ModalSize.Sm, { cancel: "Cancel", ok: "Proceed" });
          dialogRef.subscribe(result => {
            if (result) {
              // open form only if acknowledged
              var data = {
                ...this.currentData.cardData,
                remarks: "",
                anc_status: true,
                marked_by_id: this.currentData.cardData.currentTreatingDoctorId ? this.currentData.cardData.currentTreatingDoctorId : this.currentData.cardData.treatingDoctorId,
                marked_by_name: this.currentData.cardData.currentTreatingDoctor ? this.currentData.cardData.currentTreatingDoctor : this.currentData.cardData.treatingDoctor,
                closed_by_id: this.currentData.cardData.currentTreatingDoctorId ? this.currentData.cardData.currentTreatingDoctorId : this.currentData.cardData.treatingDoctorId,
                closed_by_name: this.currentData.cardData.currentTreatingDoctor ? this.currentData.cardData.currentTreatingDoctor : this.currentData.cardData.treatingDoctor,
                visit_date_time: this.currentData.cardData.g_creation_time,
                // day_visit_id: this.currentData.cardData.encounter_id //handle via backend
              }
              this.baseService.action(data, "ANC_REGISTRATION", "adt", "anc_registration").subscribe(res => {
                if (res.errCode == 0) {
                  this.alerts.success("ANC Registration Successful")
                  this.openAsideForm(componentConfig, size, display_name, action)
                } else
                  this.alerts.error(res.message)
              })
              //this.openAsideForm(componentConfig, size, display_name)
            }
          });
        } else {
          this.alerts.error("Only Female Patient above the age of 12 can be registered")
        }
      }
    })
  }
  generateFormName(resourceName:any,uhId:any,encounterId:any)
  {
    let formName =resourceName + "__" +(uhId ? uhId : "") + "__" +(encounterId ? encounterId : "");
    return formName;
  }

  addRequiredButton(){
    if (this.currentData['resouceDef']?.config && this.currentData['resouceDef']?.config.add_required_datasource) {
      let dt = this.currentData['resouceDef'].config.add_required_datasource;
      let args = this.baseService.buildDyanamicStr(dt.args, { data: this.currentData.cardData })
      this.baseService.get(dt.query_id, args, dt.resource, dt.application).subscribe(data => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          this.setAsideView();
        }
      });
    } else {
      this.setAsideView();
    }
  }

  setAsideView(action?, configObj?) {
    const localConfigObj = configObj ? structuredClone(configObj) : configObj;
    console.log("localConfigObj data=>", localConfigObj);
    if (Boolean(localConfigObj?.data?.modify_final) === true && Array.isArray(localConfigObj.customButton?.Modify)) {
      localConfigObj.customButton.Modify = localConfigObj.customButton.Modify.map(item => {
        if (this.currentResource === 'progress_note' && item.status === "Booked") {
          return { ...item, action: "UPDATE_PROGRESSNOTE_FINAL" };
        }
        else if (item.status === "final") {
          return { ...item, action: "TemplateUpdateBaseOnIdFinal" };
        }
        return item;
      });
    }
    else if (Array.isArray(localConfigObj?.customButton?.Modify) && localConfigObj?.data?._type != 'copy') {
      localConfigObj.customButton.Modify = localConfigObj.customButton.Modify.map(item => {
        if (this.currentResource === 'progress_note' && item.status === "Booked") {
          return { ...item, action: "UPDATE_PROGRESSNOTE" };
        }
        else if (item.status === "final" && this.currentResource != '' && this.currentResource != 'discharge_summary') {
          return { ...item, action: "TemplateUpdateBaseOnId" };
        }
        return item;
      });
    }
    console.log("final localConfigObj data=>", localConfigObj);
    
    if (this.currentData != undefined && this.currentData['cardData'] && this.bannerJson != undefined)
      this.bannerJson['key'] = this.currentData['cardData'];//directly set banner data 
    if (this.currentData && this.currentData['filterBlock'])
      this.currentData['filterBlock'].default_open = false;
    var display_name = this.currentData['resouceDef'].display_name != undefined ? this.currentData['resouceDef'].display_name : 'KareXpert';
    let event: any = { resource: this.currentResource, actionType: { action_name: action ? action : 'ADD', banner: this.bannerJson != undefined ? this.bannerJson : undefined }, decorator: this.currentData['resouceDef'].config && this.currentData['resouceDef'].config.decorator ? this.currentData['resouceDef'].config.decorator : '', setDefaultFormData: true, data: this.authenticationService.getUserType() == 'patient' ? this.currentData['cardData'] : {} };
    event = { ...event, ...localConfigObj }
     let autoSaveAndShowAddRequired={}
     let formName=this.generateFormName(display_name,this.bannerJson?.key?.uhId,this.bannerJson?.key?.encounter_id);
     if(this.currentData['resouceDef']?.config?.auto_save_show_add_required)
     {
      autoSaveAndShowAddRequired['formName']=formName
      autoSaveAndShowAddRequired['showAddData']=true;
      //autoSaveAndShowAddRequired['autoSave']=true
      if(action!='MODIFY')
        {
          this.templateFormName=formName;
        autoSaveAndShowAddRequired['autoSave']=true
        }
        else{
         if(formName)
         {
          let st=sessionStorage.getItem("curr_epres_unsaved_forms")
          if(st)
          {
            st=JSON.parse(st)
            if(st[formName])
            {
              delete st[formName]
              sessionStorage.setItem("curr_epres_unsaved_forms",JSON.stringify(st))
            }
          }
         }
        }
     }
    let componentConfig = {
      inputs: {
        data: event,
        autoSaveAndShowAddRequired
      }
    };
    var size = (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.size != undefined) ? this.currentData['resouceDef'].config.size : 'md';
    if (this.currentData != undefined && this.currentData['resouceDef'] != undefined && this.currentData.resouceDef.resource != undefined && this.currentData.resouceDef.resource == "anc_registration") {
      // ANC Flow
      if (this.currentData && this.currentData.selectedList && this.currentData.selectedList['observation_id']) {
        componentConfig.inputs.data['observation_anc_id'] = this.currentData.selectedList['observation_id']
      }
      this.ancRegistrationFlow(componentConfig, size, display_name, action)
    }
    else {
      this.openAsideForm(componentConfig, size, display_name, action)
    }
  }

  openAsideForm(componentConfig, size, display_name, action) {
    console.log("componentConfig:", componentConfig);
    componentConfig['inputs']['data']['templateUseCase'] = true;
    if (action == 'MODIFY') {
      this.hideEditForm = true;
    }
    const asideTitle = this.tabLayoutName || display_name;
    this.asideBarService.appendComponentTo('aside-modal-container', AsideUiEngineComponent, componentConfig, size, asideTitle).subscribe(data => {
      this.hideEditForm = false;
      if (data) {
        this.currentData['custom_button'] = undefined;
        this.saveData(data.data, data.decorator);
      }
    });
  }

  saveData(event, decorator, callback = null) {
    Object.keys(event.result).forEach(key => {
      if (event.result[key] == "null") {
        event.result[key] = null;
      }
    })
    if (event && event.result && event.result.template && Object.keys(event.result.template).length > 0)
      Object.keys(event.result.template).forEach(key => {
        if (event.result.template[key] == "null") {
          event.result.template[key] = null;
        }
      })
    var finalObj: any = {};
    // Set template variables if config type is template otherwise send the form data without any processing.
    if (this.currentData['resouceDef'].config.type != undefined && this.currentData['resouceDef'].config.type == "template" && this.currentData['resouceDef'].config.template_key)
      this.setTemplateVariables(finalObj, event);
    else
      finalObj = event.result
    // Setting parameters required for form submission from  card data
    this.setRequiredParameters(finalObj, event)
    var resource = '';
    var application = '';
    var action = '';
    var expression = undefined;
    if (this.currentData['resouceDef'].form.APIresource != undefined && this.currentData['resouceDef'].form.APIresource) {
      resource = this.currentData['resouceDef'].form.APIresource.datasource['resource'];
      expression = this.currentData['resouceDef'].form.APIresource.datasource['expression'];
      application = this.currentData['resouceDef'].form.APIresource.datasource['application'];
      action = event.currentBtnVal.action ? event.currentBtnVal.action : this.currentData['resouceDef'].form.APIresource.datasource['action'] != undefined ? this.currentData['resouceDef'].form.APIresource.datasource['action'] : 'ADD';
    }
    if (this.currentData['resouceDef'].form.beforeSubmitReq != undefined && this.currentData['resouceDef'].form.beforeSubmitReq && decorator.beforeSubmitReq) {
      finalObj = decorator.beforeSubmitReq(finalObj);
    }
    //validate Pin function
    if (decorator.name == "CertificateDecorator" || (decorator.name == "TemplateAssessment" && this.currentData.resouceDef.resource == "template_assessment") || decorator.name == "DischargeSummaryDecorator") {
      if (event.currentBtnVal.status == "final" && this.isPinRequired) {
        var inputPin = '';
        let popObj = {
          "data": [],
          "action": "ADD",
          "getdata": true,
          "layout_type": "simple",
          "application": "emr",
          "title": 'Validate PIN',
          "size": DialogModalSize.Sm,
          "resource": 'op_validate_pin',
          "customButton": {
            "Add": [
              {
                "label": "button.confirm",
                "icon": "fa fa-check"
              }
            ]
          }
        }
        this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
          if (response != undefined && response.result) {
            inputPin = response.result.pin
            this.baseService.action({ pin: inputPin }, "authenticate_pin", "account-management", "manage_user_pin").subscribe(res => {
              if (res.errCode != -1) {
                if (res.resource[0].is_authorised) {
                  finalObj.status = "final"
                  this.hitPostAPI(finalObj, action, application, resource, expression, decorator, event, callback)
                  // this.hitPostAPI(finalObj, action, application, resource, expression, decorator, callback)
                }
                else {
                  finalObj.status = "draft"
                  this.hitPostAPI(finalObj, action, application, resource, expression, decorator, callback)
                  this.alerts.error("Incorrect PIN, saved as draft")
                }
              }
              else {
                finalObj.status = "draft"
                this.hitPostAPI(finalObj, action, application, resource, expression, decorator, event, callback)
                this.alerts.error("Please generate your Pin by clicking on profile icon at the top right corner")
              }
            })
          } else {
            finalObj.status = "draft"
            this.hitPostAPI(finalObj, action, application, resource, expression, decorator, event, callback)
            this.alerts.error("PIN not entered, saved as draft")
          }
        });
      }
      else {
        this.hitPostAPI(finalObj, action, application, resource, expression, decorator, event, callback)
      }
    }
    else {
      this.hitPostAPI(finalObj, action, application, resource, expression, decorator, event, callback)
    }
    //this.hitPostAPI(finalObj, action, application, resource, expression, decorator, callback)
  }

  closeButton() {
    this.currentData.show = false;
    if (this.utilService.isMobile && document.getElementsByClassName('_table-quick-actions')) {
      let collection = document.getElementsByClassName('_table-quick-actions')
      Array.from(collection).forEach(function (element) {
        element.classList.remove('show');
      });
    }
  }

  prePrint(action, val,res?) {
    /* let prePrintObj = action.pre_print;
     action['form'] = action.pre_print.form; */
    let isPrePrintAction = true;
    let print_without_h_f = this.appService._currentSessionData.print_without_h_f;
    if(res && res.print_without_h_f != null){
        print_without_h_f = res.print_without_h_f;
    }
    console.log("print_without_h_f::::!!!", print_without_h_f);
    let defaultPrint = "Y";

    if (print_without_h_f != undefined && print_without_h_f == true && this.authenticationService.getUserType() != 'patient') {
      defaultPrint = "N";
    }
    if (action && action.isUserPrint != undefined && action.isUserPrint == true && action && action.isPrePrintAction != undefined && action.isPrePrintAction == true) {
      isPrePrintAction = true;
    }
    if (action && action.isUserPrint != undefined && action.isUserPrint == true) {
      let pre_print = {
        "title": "",
        "form": {
          "buttons": {
            "Add": [
              {
                "label": "Print",
                "action": "prePrint"
              }
            ]
          },
          "blocks": [
            {
              "name": "pre_print",
              "class_name": "null",
              "layout_type": "no-column",
              "order": 1,
              "fields": [
                {
                  "label": "Select Print Header & Footer Type?",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 2,
                  "type": "String",
                  "component": "dropdown",
                  "name": "userPrint",
                  "default": defaultPrint,
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "Y",
                        "value": "With Header & Footer"
                      },
                      {
                        "id": "N",
                        "value": "Without Header & Footer"
                      }
                    ]
                  }
                },
                {
                  "label": "Select Layout Type?",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 2,
                  "type": "String",
                  "component": "dropdown",
                  "name": "page_layout",
                  "default": "portrait",
                  "visible": isPrePrintAction,
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "landscape",
                        "value": "Landscape"
                      },
                      {
                        "id": "portrait",
                        "value": "Portrait"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      };
      var prePrintObj = pre_print;
      action['form'] = pre_print.form;
    }
    else {
      prePrintObj = action.pre_print;
      action['form'] = action.pre_print.form;
    }
    let obj: any = Object.assign({ action }, { val });
    if (this.baseService.authenticationService.getUserType() == 'patient') {
      if(action && action.file_data && action.file_data.args){
        action.file_data.args = action.file_data.args != undefined && action.file_data.args != "" ? action.file_data.args + ",userPrint:Y,page_layout:portrait" : "userPrint:Y,page_layout:portrait";
      }else {
        let action = {file_data:{args:""}};
        action.file_data.args = "userPrint:Y,page_layout:portrait";
      }
      let patient_action = JSON.parse(JSON.stringify(action));
      this.userPrintFunction(patient_action, { result: { userPrint: defaultPrint, page_layout: 'portrait' } });
      return;
    }
    this.smartModalService.open(DynamicPopUpComponent, obj, prePrintObj.title != undefined ? prePrintObj.title : "", ModalSize.Md).subscribe(res => {
      if (res && res.result.userPrint) {
        if (this.currentData?.decorator?.printClick) {
          this.currentData.decorator.printClick(this.currentData['selectedList'], this, (cb) => {
            if (cb) {
              this.userPrintFunction(action, res)
            } else {
              this.loader.hideSpinner();
            }
          })
        } else {
          this.userPrintFunction(action, res)
        }
      }
    },
      err => {
        console.log("err");
      }
    );
  }

  userPrintFunction(action, res) {
    if (action && action.action == 'cumulative_print') {
      let action_ = JSON.parse(JSON.stringify(action));
      let str = res.result;
      if (str) {
        for (let key in str) {
          if (key != undefined && str[key] != undefined && str[key]) {
            action_.file_data.args = action_.file_data.args + "," + key + ":" + str[key];
          }
        }
      }
      this.handleFile(action_, { data: this.currentData.cardData, actionType: action_ });
    } else if (action && action.bulk_print && this.labBulkPrintItem && this.labBulkPrintItem.length > 0) { // Diagnostic Bulk print
      if (action.file_data != undefined && action.file_data.file_data.cumulativeInfo != undefined && this.labBulkPrintItem != undefined && this.labBulkPrintItem.length > 0) {
        if (typeof action.file_data.file_data.cumulativeInfo == 'string')
          action.file_data.file_data.cumulativeInfo = action.file_data.file_data.cumulativeInfo
        let cumulativeInfo = this.baseService.createCumilativeObj({ action: action.file_data, items: this.labBulkPrintItem });
        action.file_data.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
      }
      this.handleFile(action.file_data, this.labBulkPrintItem);
    } else {
      if (this.currentData.selectedList && this.currentData.selectedList['view_selected_config'] && this.currentData.selectedList['view_selected_config'].url) {
        action.url = this.currentData.selectedList['view_selected_config'].url.replace('args=', 'args=userPrint:' + res.result.userPrint + ',');
      }
      else {
        action.url = action.url.replace('args=userPrint:N,', 'args=');
        action.url = action.url.replace('args=userPrint:Y,', 'args=');
        action.url = action.url.replace('args=', 'args=userPrint:' + res.result.userPrint + ',');
      }
      this.urlMaker(action.url, (url) => {
        this.currentData.selectedList.url = undefined;
        this.makeImageFromUrl(url)
      });
      this.pre_print_check = false
      this.onButtonClicked(action, res.result.userPrint)
    }
  }

  handleFile(action, obj, callback = null) {
    this.loader.stophideSpinner(true);
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
      fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : undefined;
      fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this.currentData.bannerJson != undefined && this.currentData.bannerJson.key != undefined) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this.currentData.bannerJson.key.facility_id);
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
      if (action?.action == "cumulative_print" && this.filter?.filter?.includes('templateId:') && this.currentData?.selectedList && this.currentData?.selectedList['templateId']) {
        fileObj.args = fileObj.args + ",template_id:" + this.currentData.selectedList['templateId']
      }
      if (action.action == "print-async") {
        fileObj.action = action.action;
      }
      this.baseService.handleFile(fileObj, async (fileData) => {
        this.loader.stophideSpinner(false);
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.printErrorMessage && response.printErrorMessage != undefined) {
                response["printErrorMessage"] = this.utilService.extractTextContent(response.printErrorMessage);
              }
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              if (fileObj.action && fileObj.action == "print-async" && response.errCode == 0 && response.message != undefined) {
                this.alerts.success(response.message, "", true);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, 'print', fileData, callback);
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      });
    } else {
      this.loader.stophideSpinner(false);
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }

  checkPreviousButton() {
    return (this.pagination.selected_index == 0) ? '' : null
  }

  checkNextButton() {
    return ((this.pagination.selected_index == 9) || (((this.pagination.page_no ? this.pagination.page_no : 0) * 10) + this.pagination.selected_index == this.currentData['count'] - 1)) ? '' : null
  }

  cumulativePrint(btn) {
    if (btn?.selector) {
      const obj = {
        data: {
          "selector": btn.selector,
          "item": JSON.parse(JSON.stringify(this.currentData.cardData || {})),
          "action": btn,
          "ehr_view_default": this.currentData?.ehr_view
        },
        title: btn.title || btn.label || "Patient Visit",
        card_data: this.currentData.cardData,
        ehr_view: this.currentData.ehr_view
      };
      this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => { }, err => { });
      return;
    }

    let object = {
      resource: btn.resource,
      action: "LIST",
      data: this.currentData.cardData,
      config: {
        "print_allowed": false,
        "viewAll": true,
        "hideSearchBox": true,
        "hideResult": true,
        "allowPagination": true,
        "read_scope_level": true
      }
    }
    this.smartModalService.open(PopupFormComponent, object, "Patient Visit", ModalSize.Md).subscribe(res => { }, err => { })
  }

  popupFormButton(btn, action) {
    let obj = {
      data: {
        "selector": btn.selector,
        "item": JSON.parse(JSON.stringify(this.currentData['selectedList'])),
        "action": action
      },
      title: btn.label,
      card_data: this.currentData.selectedList,
      ehr_view: this.currentData.ehr_view
    }
    this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => {

    });
  }

  onButtonClicked(btn, userPrint?, entity?, clickEvent?) {
    this.currentButtonAction = btn?.action;
    this.currentData['custom_button'] = undefined;
    if (this.isActionRestricted(btn, entity))
      return;
    if ((btn?.action == 'print' || btn?.action == 'cumulative_print') && clickEvent?.ctrlKey && btn.file_data != undefined) {
      const asyncAction = JSON.parse(JSON.stringify(btn));
      asyncAction.action = "print-async";
      const actionData = entity != undefined ? entity : (this.currentData && this.currentData['selectedList'] ? this.currentData['selectedList'] : this.currentData['cardData']);
      this.handleFile(asyncAction, { data: actionData, actionType: asyncAction });
      return;
    }
    if ((btn.pre_print != undefined && btn.pre_print && btn.url && this.pre_print_check) || (btn.isUserPrint != undefined && btn.isUserPrint && btn.url && this.pre_print_check && btn.action != 'cumulative_print') || (btn.action == 'cumulative_print' && !this.currentData.ehr_view && this.pre_print_check)) {
      // this.prePrint(btn, '');
     if (this.baseService.authenticationService.getUserType() == 'patient') {
      const argsRes = {
        result: {
          userPrint: 'Y',
          page_layout:"portrait"
        }
      };
      this.userPrintFunction(btn, argsRes)
     } else{
      try {
          console.log("Inside PTS Condition viewer");
          let templateId = btn?.file_data?.template;
          if (!templateId && btn?.url) {
              templateId = this.utilService.extractValueFromUrlArgsParam(btn.url, 'reportTemplateId');
          }
          this.utilService.performPreprintAction(
            this.baseService,
            btn,
            (res: any) => this.prePrint(btn, '', res),
            (res: string) => {
              const argsRes = {
                result: {
                  userPrint: res
                }
              };
              this.userPrintFunction(btn, argsRes)
            },
            templateId,
            false
          )
      } catch (err) {
          console.error("Unexpected error in match block:", err);
          this.prePrint(btn, '');
      }
    }
      return;
    }
    if (btn.action == 'cumulative_print' && this.currentData.ehr_view) {
      this.cumulativePrint(btn);
      return;
    }
    if (btn.action == 'print' || (btn.action == 'cumulative_print' && !this.currentData.ehr_view)) {
      this.pre_print_check = true
      // Add by Sanjay for PrintEngine: resource is prescription_history pdf url should contain application_name
      if (btn.type != undefined && btn.type == "pdf" && btn.reportTemplateId != undefined && btn.reportTemplateId != "") {
        var reportTemplateId = btn.reportTemplateId;
        // var app_name = this.baseService.printApplicationName(reportTemplateId);
        var file_url = btn.url;
        if (file_url.indexOf('!!!application_name!!!') > -1) {
          file_url = file_url.replace('!!!application_name!!!', 'printengine');
        }
        btn.url = file_url;
      }
      if (this.currentData['selectedList'] && this.currentData['selectedList']['document_id'] != undefined && this.currentData['selectedList']['s3'] == true && userPrint && userPrint == 'Y') {
        let url1 = this.baseService.getApiEndpoint("dms") + this.currentData.document_type + '/image-response-entity?path=' + this.currentData['selectedList']['document_id'] + '&application=dms';
        this.baseService.getFileByUrl(url1, false).subscribe((res: any) => {
          if (res) {
            console.log("Url is ", res);
            let url = URL.createObjectURL(res);
            if (this.appService.checkNativeApp()) {
              this.baseService.nativeFileHandling(res, "application/pdf", 'Doc.' + btn.type);
            } else {
              window.open(url, '_blank');
            }
          }
        });
      } else
        if (this.currentData['selectedList']['url'] != undefined) {
          if (this.appService.checkNativeApp()) {
            this.baseService.nativeFileHandling(this.currentData.selectedList.urlBlob, this.currentData.selectedList.urlBlob.type, this.currentData.selectedList.urlFileName);
          } else {
            window.open(this.currentData['selectedList']['url'], '_blank')
          }
        } else if (btn.url != undefined) {
          this.urlMaker(btn.url, (url) => {
            if (this.appService.checkNativeApp()) {
              this.baseService.getFileByUrl(url, false).subscribe((blobUrl: any) => {
                if (blobUrl) {
                  this.baseService.nativeFileHandling(blobUrl, "application/pdf", this.currentData.selectedList.urlFileName);
                } else {
                  this.alerts.error("Error");
                }
              });
            } else {
              window.open(url, '_blank');
            }
          })
        }
    } else if (btn.action == 'confirm' && this.currentData['selectedList'].id != undefined && btn.datasource != undefined) {
      if (btn.datasource['data'] != undefined && btn.datasource['data'].indexOf('!!!') != -1) {
        var button = this.baseService.buildDyanamicStr(btn.datasource['data'], { data: this.currentData['selectedList'] })
        var obj = {}, i;
        var KeyVal = button.split(",");
        for (let i in KeyVal) {
          KeyVal[i] = KeyVal[i].split(":");
          obj[KeyVal[i][0]] = KeyVal[i][1];
        }
      } else {
        var obj = {}
        obj = this.currentData['selectedList'];
      }
      this.modalService.confirm("Confirm", btn.message).subscribe(result => {
        if (result) {
          this.baseService.action(obj, btn.datasource.action, btn.datasource.application, btn.datasource.resource).subscribe(res => {
            if (res.errCode == 0) {
              this.getHistory();
              this.alerts.success("Deleted Successfully...")
            } else {
              this.alerts.error(res.message)
            }
          })
        }
      })
    } else if (btn.action == 'modify') {
      this.populateForm(btn)
    }  else if (btn.action == 'modify_final') {
      let selectedData = this.currentData.selectedList;
      selectedData.modify_final = true;
      this.populateForm(btn, undefined, selectedData);
    } else if (btn.action == 'popup_form') {
      let item = this.currentData.selectedList; //used in expression
      if (btn.check_condition) {
        btn.selector = undefined;
        let data = { args: "" };
        var cardData = JSON.parse(JSON.stringify(this.currentData.cardData));
        if (cardData.part_of_package)
          cardData['patientType'] = 'PHC';
        else if (cardData.patient_type)
          cardData['patientType'] = cardData.patient_type;
        if (btn.check_condition.args != undefined && btn.check_condition.args.indexOf('!!!') != -1)
          data.args = this.baseService.buildDyanamicStr(btn.check_condition.args, { data: cardData })
        if (localStorage.currentUser) {
          let c_user = JSON.parse(localStorage.currentUser);
          if (c_user.role_type && c_user.role_type.toLowerCase() == "practitioner") {
            data.args += ',doctor_id:' + c_user.user_id;
            if(!cardData.speciality_id)
            {
              data.args += ',speciality_id:' + item.speciality_id;
            }
            if (!cardData.patient_type) {
              data.args += ',patient_type:' + item.patient_type;
            }
          } else {
            if(cardData?.treatingDoctorId)
              {
                data.args += ',doctor_id:' + cardData.treatingDoctorId; 
              }
              else {
                data.args += ',doctor_id:' + item.practitioner_id;
              }
  
              if (!cardData.speciality_id) {
                data.args += ',speciality_id:' + item.speciality_id;
              }
              if (!cardData.patient_type) {
                data.args += ',patient_type:' + item.patient_type;
              }
          }
        } else {
          data.args += ',doctor_id:' + cardData.treatingDoctorId;
        }
        this.loader.showSpinner();
        this.baseService.getData(data, "", btn.check_condition.resource, btn.check_condition.application, btn.check_condition.queryId).subscribe(res => {
          if (res && res.resource && res.resource.length > 0) {
            let current_version = res.resource[0];
            if (btn.selector_condition) {
              btn.selector_condition.forEach(element => {
                if (element.selector_expression && eval(element.selector_expression)) {
                  btn.selector = element.selector;
                  btn.input = element.input;
                  if (element.set_data) {
                    item = { ...item, ...element.set_data }
                    this.currentData['selectedList'] = item;
                  }
                }
              });
            }
            if (btn.selector) {
              this.popupFormButton(btn, action);
            } else if(this.currentData.selectedList?.prescription_model && this.currentData.selectedList?.prescription_model == 'v1'){
              btn = {
                "selector": "app-v1-prescription",
                "input": "emr_v1_format"
              }
              this.currentData['selectedList'] = item;
              this.popupFormButton(btn, action);
            } else if(this.currentData.selectedList?.prescription_model && (this.currentData.selectedList?.prescription_model == 'v0' || this.currentData.selectedList?.prescription_model == '')){
              btn = {
                "selector": "op-prescription",
                "input": "op_prescription",
              }
              this.currentData['selectedList'] = item;
              this.currentData['selectedList'].parental = true;
              this.popupFormButton(btn, action);
            } else {
              this.alerts.error(btn.error_msg);
            }
          }
          this.loader.hideSpinner();
        });
      } else if (btn.selector_condition) {
        btn.selector_condition.forEach(element => {
          if (element.expression && eval(element.expression)) {
            btn.selector = element.selector;
            btn.input = element.input;
          }
        });
      }
      if (btn.selector) {
        this.popupFormButton(btn, action);
      } else if (btn.form) {
        var action = btn;
        if(btn.config_check_permission){
          this.baseService.get(btn.config_check_permission.query_id, btn.config_check_permission.args, btn.config_check_permission.resource, btn.config_check_permission.application).subscribe(data => {
            if (data.errCode == 0 && data.resource.length > 0) {
              if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "all"){
                this.popupAction(btn, action);
              }else  if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "creator"){
                if(this.authenticationService.getCurrentUser().user_id == this.currentData.selectedList.g_modified_by_id || this.authenticationService.getCurrentUser().user_id == this.currentData.selectedList.g_created_by_id){
                  this.popupAction(btn, action);
                }else{
                  this.alerts.error("Editing access is limited to the creator of the document.");
                }
              }else  if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "department"){
                if(this.authenticationService.getCurrentUser().user_id == this.currentData.selectedList.g_modified_by_id || this.authenticationService.getCurrentUser().user_id == this.currentData.selectedList.g_created_by_id){
                  this.popupAction(btn, action);
                }else if(this.currentData.dept_id == this.currentData.selectedList.finalized_by_user_department_id){
                  this.popupAction(btn, action);
                }else{
                  this.alerts.error("Editing access is limited to the department of the document.");
                }
              }
            }else{
              this.popupAction(btn, action);
            }
          });
        }else
          this.popupAction(btn, action);
      }
    } else if (btn.action == 'view') {
      this.currentData['selectedList'] = entity == undefined ? this.currentData['selectedList'] : entity;
      this.hitSecondaryDataSource((this.currentData['selectedList'] == undefined ? entity : this.currentData['selectedList']), "", true)
      // this.onClickSideList(this.currentData['selectedList'], true)
      setTimeout(() => {
        this.currentData.show = true;
      })
    } else if (btn.action == 'copy') {
      //it was only used in progress note now we will handle it from decorator so removed it
      // if (this.currentData.selectedList.observationId)
      //   this.currentData.selectedList.observationId = "";
      // delete this.currentData.selectedList.id
      if (btn.custom_button){
        this.currentData['custom_button'] = btn.custom_button;
        /* Removing expression only from Preview button. */
        this.currentData['custom_button'].Add.forEach(element => {
          if (element.label == "button.preview") {
            delete element.expression;
          }
        });
        this.currentData['custom_button'].Modify.forEach(element => {
          if (element.label == "button.preview") {
            delete element.expression;
          }
        });
      }
      let config = {};

      config['action'] = 'copy';
      this.populateForm(btn, config)
      // this.initializeDecorator((cb) => {
      //   this.currentData.decorator.hitDecoratorEvent(btn, this.currentData['selectedList'],this,(cb)=>{
      //     if(cb)
      //     this.getHistory()
      //   });
      // })
    } else if (btn.action == 'addendum') {
      this.populateForm(btn);
    }
  }

  async popupAction(btn, action){
    if (!(await this.canOpenTemplateForm(btn, this.currentData['selectedList'])))
      return;
    var val = {};
    if (btn.saveData) {
      for (let key in btn.saveData) {
        if (this.currentData.selectedList[btn.saveData[key]] == undefined) {
          val[key] = this.currentData.selectedList['id']
        } else
          val[key] = this.currentData.selectedList[btn.saveData[key]]
      }
    } else {
      val = this.currentData['selectedList'];
    }
    let obj: any = Object.assign({ action }, { val });
    this.smartModalService.open(DynamicPopUpComponent, obj, btn.title, ModalSize.Sm).subscribe(res => {
      if (res) {
        this.currentData.list = [];
        this.getHistory();
    }
    },
          err => {
            console.log("err");
          }
        );
  }

  popUpFormAction(btn){
    var action = btn;
    var val = {};
    if (btn.saveData) {
      for (let key in btn.saveData) {
        if (this.currentData.selectedList[btn.saveData[key]] == undefined) {
          val[key] = this.currentData.selectedList['id']
        } else
          val[key] = this.currentData.selectedList[btn.saveData[key]]
      }
    } else {
      val = this.currentData['selectedList'];
    }
    let obj: any = Object.assign({ action }, { val });
    this.smartModalService.open(DynamicPopUpComponent, obj, btn.title, ModalSize.Sm).subscribe(res => {
      if (res) {
        this.currentData.list = [];
        this.getHistory();
      }
      },err => {
        console.log("err");
    });
  }

  initializeDecorator(cb) {
    if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.decorator != undefined) {
      //if decorator  not initialzed or its not same as previous decorator then initialze it
      if (!this.currentData.decorator || (this.currentData.decorator && this.currentData.decorator.className != undefined && this.currentData.decorator.className != this.currentData['resouceDef'].config.decorator))
        this.currentData.decorator = this.baseService.initDecorator(this.currentData['resouceDef'].config.decorator, this.route, this.injector);
    }
    cb(true)
  }

  /**
   * Resolves the system template id from a saved document. Template screens store it as
   * `templateId`, progress_note as `template_type_id`.
   * @param data the selected list record
   * @returns the template id, or undefined for documents saved without a template
   */
  getTemplateId(data) {
    return data?.templateId || data?.template_type_id;
  }

  /**
   * Checks whether a system template is still active. Resolves true unless the lookup
   * succeeds and returns nothing, so an API failure never blocks an edit.
   * @param templateId the system template id to look up
   * @returns promise resolving to false only when the template is confirmed in-active
   */
  isTemplateActive(templateId): Promise<boolean> {
    this.loader.showSpinner();
    let obj = {
      filter: `_id:${templateId},status:active`,
      projectionKeys: ['id', 'status']
    };
    return new Promise((resolve) => {
      this.baseService.getData(obj, '', 'system_template', 'form-template-engine', 'GET_PAGE').subscribe(
        (res: any) => {
          this.loader.hideSpinner();
          resolve(res && res.errCode === 0 ? res.resource?.length > 0 : true);
        },
        () => {
          this.loader.hideSpinner();
          resolve(true);
        }
      );
    });
  }

  /**
   * Blocks modify, modify_final, copy and addendum (action_name 'definalize') on template screens
   * (config.type == 'template') when the document's template is in-active. Alerts the user before refusing.
   * @param btn the action button that was clicked
   * @param selectedData the document the action was raised on
   * @returns promise resolving to false when the aside must not be opened
   */
  async canOpenTemplateForm(btn, selectedData): Promise<boolean> {
    if (btn?.action == 'copy' && ['discharge_summary', 'pac_template', 'progress_note', 'template_assessment_final', 'template_assessment'].includes(this.currentResource) && !this.copyRuleAllowed) {
      this.alerts.error(this.copyRuleRemark || 'Copy functionality is restricted for facility');
      return false;
    }
    let templateId = this.getTemplateId(selectedData);
    if (!templateId ||
      (['modify', 'modify_final', 'copy'].indexOf(btn?.action) == -1 && btn?.action_name != 'definalize') ||
      this.currentData['resouceDef']?.config?.type != 'template')
      return true;
    if (await this.isTemplateActive(templateId))
      return true;
    this.alerts.error("This Template Is Inactive and Changes cannot be made.");
    return false;
  }

  /**
   * Opens the aside form for an existing document. Which form definition is used:
   * - btn.notToCheckExpression == true - the resource's own JSON `form`; the template questions
   *   are built afterwards by the templateId field's createComponentDatasource.
   * - record carries `template` - fetched through GET_TEMPLATE_FORM_BY_ID, which openAsideView
   *   then discards when config.preserveTemplate is true.
   * - neither - nothing opens.
   * @param btn the action button that was clicked
   * @param config extra config forwarded to the aside, carries action 'copy' on the copy flow
   * @param selectedData the document to load, defaults to the currently selected list item
   */
  async populateForm(btn, config?, selectedData?) {
    if (!selectedData) {
      selectedData = this.currentData['selectedList'];
    }
    if (!(await this.canOpenTemplateForm(btn, selectedData)))
      return;
    if (btn.notToCheckExpression != undefined && btn.notToCheckExpression == true) {
      this.openAsideView(this.currentData['resouceDef'].form, btn.action, config)
    } else if (selectedData.template != undefined) {
      if (this.currentData['resouceDef'].config && this.currentData['resouceDef'].config.type == "template")
        this.loader.showSpinner()
      selectedData = this.setDataInsideForm(selectedData);
      // this.baseService.getById(this.currentData['selectedList'].template.templateId, 'template', 'form-template-engine').subscribe(res => {
      var data = { args: "id:" + (selectedData.template.templateId == undefined ? selectedData.template_id : selectedData.template.templateId) }
      this.baseService.getData(data, "", 'template', 'form-template-engine', 'GET_TEMPLATE_FORM_BY_ID').subscribe(res => {
        // Deleting name to avoid addition of prefix in question name
        if (res.name)
          delete res.name
        this.openAsideView(res, btn.action, '', selectedData)
      }, err => {
        this.loader.hideSpinner();
      })
    }
  }

  openAsideView(res, action, config?, selectedData?) {
    if (!selectedData) {
      selectedData = this.currentData['selectedList'];
    }
    let _data = selectedData.template ? selectedData.template : selectedData;
    if (action && (action == "modify" || action == "modify_final")) {
      _data["id"] = selectedData.id;
      if(action == "modify_final")
        _data["modify_final"] = selectedData.modify_final;
    }
    let obj = {
      data: _data,
      form: this.currentData['resouceDef'].config.preserveTemplate ? this.currentData['resouceDef'].form : res,
      customButton: this.currentData['custom_button'] ? this.currentData['custom_button'] : this.currentData['resouceDef'].custom_button,
      config: config
    }
    // if(selectedData && obj["data"] ){
    //   //obj["data"]["selected_garbage_data"] = selectedData;
    // }
    if(selectedData && selectedData.templateId){
      this.storageService.setLocalStorageData('templateId', selectedData.templateId,()=>{});
    }
    if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.decorator != undefined) {
      //if decorator  not initialzed or its not same as previous decorator then initialze it
      if (!this.currentData.decorator || (this.currentData.decorator && this.currentData.decorator.className != undefined && this.currentData.decorator.className != this.currentData['resouceDef'].config.decorator))
        this.currentData.decorator = this.baseService.initDecorator(this.currentData['resouceDef'].config.decorator, this.route, this.injector);
    }
    if (this.currentData.decorator.setEditData) {
      obj['action_name'] = action
      let data = this.currentData['selectedList'] || selectedData;
      this.currentData.decorator.setEditData(obj, data, this, (cb) => {
        this.setAsideView('MODIFY', cb)
      });
    } else
      this.setAsideView('MODIFY', obj)
  }

  /**
   * Keeps an action button visible but blocks the click with an alert, for rules the user
   * should be told about rather than left guessing at a missing button (e.g. a frozen
   * discharge summary). Counterpart to showBtn, which hides instead.
   *
   * "restrict_conditions": [ { "expression": "item['isMrdFreezed'] == true",
   *                            "message": "Discharge summary is freezed, cannot be modified." } ]
   *
   * First matching condition wins. Write expressions against `item`; a bad expression is
   * ignored rather than allowed to block the button, matching showBtn's catch.
   */
  isActionRestricted(btn, entity?: any): boolean {
    if (!btn || !btn.restrict_conditions || !btn.restrict_conditions.length)
      return false;
    let item = entity || this.currentData['selectedList'];
    if (!item)
      return false;
    for (let condition of btn.restrict_conditions) {
      if (!condition || !condition.expression)
        continue;
      try {
        if (eval(condition.expression)) {
          if (condition.message)
            this.alerts.error(condition.message);
          return true;
        }
      } catch (error) {
        console.error('restrict_conditions expression failed', condition.expression, error);
      }
    }
    return false;
  }

  showBtn(btn,entity?:any) {
    // if (btn.action_name == "definalize" && this.currentData['cardData'] && this.currentData['cardData'].patientType == 'OP' && this.currentResource == "template_assessment_final" && (this.currentData['cardData'].stage == 'Prescription Sent' || this.currentData['cardData'].payment_status == 'Completed')) {
    //   btn['showAtView'] = true;//enable addendum for viewEmr
    // }
    let exp=btn?.expression;
    if (this.hideEdit && btn.action == 'modify')
      return false
    else if (btn.expression != undefined) {
      let item = this.currentData['selectedList'];
      if (this.utilService.isMobile() && entity) {
        item = entity || this.currentData['selectedList'];
        if (exp) {
          const regex = /this\s*\??\.\s*currentData\s*\??\.\s*selectedList/g;
          //exp = exp.replaceAll('this.currentData.selectedList', 'item');
          exp = exp.replace(regex, 'item');
        }
      }
      try { 
        if (item && eval(exp))
          return true;
        else
          return false;
      } catch (error) {
        return false;
        console.error(error);
      }
    } else
      return true;
  }

  setTemplateVariables(finalObj, event) {
    // Setting templateId, name and type for case of edit
    // if (event.action != 'ADD' && this.currentData.selectedList != undefined && (event.result['templateId'] == undefined || event.result['templateName'] == undefined || event.result['templateType'] == undefined)) {
    //   event.result['template_id'] = this.currentData.selectedList['template_id'];
    //   event.result['template_name'] = this.currentData.selectedList['template_name'];
    //   event.result['template_type'] = this.currentData.selectedList['template_type'];
    //   event.result['templateId'] = this.currentData.selectedList['templateId'];
    //   event.result['templateName'] = this.currentData.selectedList['templateName'];
    //   event.result['templateType'] = this.currentData.selectedList['templateType'];
    //   event.result['title'] = this.currentData.selectedList['title'];
    // }
    // Setting templateId, name and type in main Object
    let _data = event.result;
    if (_data && _data.template) {
      _data = _data.template;
    }
    finalObj['templateId'] = _data['templateId'];
    finalObj['templateName'] = _data['templateName'];
    finalObj['templateType'] = _data['templateType'];
    finalObj['template_id'] = _data['template_id'];
    finalObj['template_name'] = _data['template_name'];
    finalObj['template_type'] = _data['template_type'];
    finalObj['isRelay'] = _data['isRelay'];
    finalObj['title'] = _data['title'];
    if (_data && _data['confidential'] != undefined) {
      finalObj['isConfidential'] = _data['confidential'];
      finalObj['is_confidential'] = _data['confidential'];
    }
    if (event?.result?.isConfidential && event.action == 'MODIFY') {
      finalObj['isConfidential'] = event.result.isConfidential;
      finalObj['is_confidential'] = event.result.isConfidential;
    }
    if ((event?.result?.document_date_time || event?.result?.template?.document_date_time) && (event.action == 'ADD' || event?.result?._type == "copy")) {
      if (event?.result?._type == "copy" && event?.result?.template?.document_date_time) {
        finalObj['template_creation_date_time'] = event.result.template.document_date_time;
        finalObj['g_creation_time'] = event.result.template.document_date_time;
      } else if(event?.result?.document_date_time){
        finalObj['template_creation_date_time'] = event.result.document_date_time;
        finalObj['g_creation_time'] = event.result.document_date_time;
      }
    }
    if (this.authenticationService.getUserType() == 'patient' && _data['patient_template_accessibility'] == true) {
      var template_patient_type = [{ id: "OP", text: "OP" }];
      finalObj['template_patient_type'] = _data['template_patient_type'] && _data['template_patient_type'].length > 0 ? _data['template_patient_type'] : template_patient_type;
      delete _data['template_patient_type'];
    }
    // Setting template data and status
    let arr = ['confidential', 'templateId', 'templateName', 'templateType', 'title', 'template_id', 'template_name', 'template_type'];
    arr.forEach(element => {
      if (event.action === 'ADD' && _data && _data[element])
        delete event.result[element];
      if (event.action === 'MODIFY' && _data && _data.template && _data.template[element]) {
        delete _data.template[element]
      }
    });
    finalObj[this.currentData['resouceDef'].config.template_key] = event.action != "ADD" ? (_data.template ? _data.template : _data) : _data
    finalObj.status = event.currentBtnVal.status;
  }

  setRequiredParameters(finalObj, event) {
    // Setting id for edit case
    if (event.action == 'MODIFY') {
      if (event.currentBtnVal.action == 'TemplateUpdateBaseOnId' && this.currentResource == 'anc_registration')
        finalObj.id = event['observation_anc_id'];
      else
        finalObj.id = event.result.id;
    }
    // Setting required keys from card data non-conditionally
    if (this.currentData['resouceDef'].required_keys) {
      for (let key of this.currentData['resouceDef'].required_keys) {
        /** 197617 comment this code because removing  all_visit_template filter due to ehr toggle functionality is available **/
        //let visitKey = this.currentData.selectedList && this.currentData.selectedList['patientType'] == 'OP' ? 'episode_id' : 'encounter_id';
        // if (this.filter && this.filter.filter && this.filter.filter.includes('all_visit_template:true') && this.currentData.selectedList && this.currentData.selectedList[visitKey] != this.currentData.cardData[visitKey]) {
        //   if (this.currentData.selectedList[key])
        //     finalObj[key] = this.currentData.selectedList[key];//set old visit data
        // } else
          finalObj[key] = this.currentData.cardData[key]
      }
    }
    // Setting required keys from card data non conditionally
    if (this.currentData['resouceDef'].dynamic_required_keys) {
      for (let key in this.currentData['resouceDef'].dynamic_required_keys) {
        try {
          finalObj[key] = eval(this.currentData['resouceDef'].dynamic_required_keys[key])(this.currentData.cardData)
        } catch (error) {
          console.error(error);
        }

      }
    }
    //addind  definalization status key from observation these keys will be common for definalization throug the system 
    if (this.currentData.resouceDef.config != undefined && this.currentData.resouceDef.config.definalize != undefined && this.currentData.selectedList != undefined && this.currentData.selectedList['isDefinalize'] != undefined && this.currentData.selectedList['template_version'] != undefined && event.action != 'ADD') {
      finalObj['isDefinalize'] = this.currentData.selectedList['isDefinalize'];
      finalObj['template_version'] = this.currentData.selectedList['template_version'];
    }
  }
  goBack() {
    this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
  }

  relayCall(item) {
    let role = JSON.parse(localStorage.CURRENT_ROLE);
    let selected = {
      "doctor_id": this.authenticationService.getCurrentUser().user_id,
      "doctor": this.authenticationService.getCurrentUser().first_name,
      "type": "template",
      "type_id": "template",
      "patientType": this.currentData.cardData.patientType,
      "currentTreatingDoctor": item.currentTreatingDoctor,
      "currentTreatingDoctorId": item.currentTreatingDoctorId,
      "speciality_name": item.currentTreatingDoctorSpeciality,
      "speciality_id": item.currentTreatingDoctorSpecialityId,
      "department_id": this.currentData.cardData.treating_department_id,
      "department_name": this.currentData.cardData.treating_department_name,
      "favourite_name": item.templateName,
      "role": role.role,
      "role_type": role.role_type,
      "template_favourite": {
        "templateId": item.templateId,
        "templateName": item.templateName,
        "templateType": item.templateType
      }
    }
    this.baseService.action(selected, 'ADD', 'emr', 'doctors_favourite').subscribe(
    (data: any) => { })
  }

hitPostAPI(item, action, application, resource, expression, decorator, event, callback = null) {
  if (expression == undefined || eval(expression)) {
    this.loader.showSpinner();

    // Capture current pagination state before API call
    const currentPaginationState = {
      page_no: (event?.action == 'ADD' || this.currentButtonAction == 'copy') ? 0 : (this.pagination.page_no || 0),
      selected_index: (event?.action == 'ADD' || this.currentButtonAction == 'copy') ? 0 : (this.pagination.selected_index || 0)
    };

    console.log(`Pre-API pagination state:`, currentPaginationState);

    if (item.isRelay === true) {
      this.relayCall(item);
    }
    this.baseService.action(item, action, application, resource).subscribe(
      (data: any) => {
        if (data.errCode == 0) {
           // Restore pagination state before saving
          this.pagination.page_no = currentPaginationState.page_no;
          this.pagination.selected_index = currentPaginationState.selected_index;
          this.activeValue = currentPaginationState.selected_index;
          
          if(!event?.currentBtnVal?.previewPrintURL || event?.currentBtnVal?.previewPrintURL.trim() == ''){
            this.asideBarService.removeComponent();
            this.asideBarService.setCloseSideBAr(false)
          }
          this.currentData['selectedList'] = data.resource[0];
          this.alerts.success("Added Successfully");
          if (event && event.currentBtnVal && event.currentBtnVal.url != undefined) {
            if (action == 'AddTemplate' || (this.currentData != undefined && this.currentData['resouceDef'] != undefined && this.currentData.resouceDef.resource != undefined && this.currentData.resouceDef.resource == "anc_registration"))
              this.currentData['selectedList'] = data.resource[0];
            let btn = {
              "action": "print",
              "url": event.currentBtnVal.url
            }
            // let fileObj = event.currentBtnVal.file_data; 
            // if (fileObj && fileObj.args)
            //   fileObj.args = this.baseService.buildDyanamicStr(fileObj.args, { data: this.currentData['selectedList']  })
            //   this.baseService.handleFile(fileObj, (fileData) => {
            //   if (fileData) {
            //     this.printService.handleFileReponse(fileObj, 'print', fileData, callback);
            //   } else {
            //     this.alerts.error('server error');
            //     if (callback) {
            //       callback(false);
            //     }
            //   }
            // });
            this.onButtonClicked(btn);
          }
          if (event?.currentBtnVal?.previewPrintURL) {
            let finalPreviewUrl = JSON.parse(JSON.stringify(event.currentBtnVal.previewPrintURL));
            console.log("Before Preview Print URL: ", finalPreviewUrl);
            if(this?.resource?.resource === "progress_note" && (!data?.resource[0]?.observationId || data?.resource[0]?.observationId === "")){
              // This condition only works for progress note when observationId is not present
              finalPreviewUrl = finalPreviewUrl
                .replace('id:!!!observationId!!!', 'id:!!!id!!!')
                .replace('queryId=GET_TEMPLATE_WITH_ANS', 'queryId=GET_PROGRESSNOTE_FOR_PRINT')
                .replace('reportTemplateId:progressNoteEMR', 'reportTemplateId:progressNote');

                // Append ,uhId:!!!uhId!!! if not already present
                if (!/[,?&]uhId:!!!uhId!!!/.test(finalPreviewUrl)) {
                  finalPreviewUrl += ',uhId:!!!uhId!!!';
                }
            }
            console.log("After Preview Print URL: ", finalPreviewUrl);
            const url = this.baseService.buildDyanamicStr(finalPreviewUrl, { data: data.resource[0] });
            this.baseService.getFileByUrl(url, false).subscribe(res => {
              const url2 = URL.createObjectURL(res);
              var config = {
                data: { blob: url2, isBlob: true },
                title: 'Preview',
                size: DialogModalSize.Md
              }
              this.loader.hideSpinner();
              this.isPrintOpenInPopup = true;
              const popupModel = this.dialogService.open(PDFViewerComponent, config);
              popupModel.afterClosed.subscribe(response => {
                // delete popupModel;
                this.isPrintOpenInPopup = false;
              });
              let obj = {
                action: "modify",
                class: "fa fa-edit",
                expression: "item['status'] != 'final' && item['status'] != 'amended' && this.currentData.cardData['encounter_id'] == item['encounter_id']",
                key: "id",
                label: "Edit",
                notToCheckExpression: this?.resource?.resource === "progress_note" ? true : undefined,
              }
              this.asideBarService.isPreviewFormReopened = true;
              this.populateForm(obj, undefined, data.resource[0]);
            })
          }
          this.savePaginationState();
        }
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (callback) {
            callback(false);
          }
        } else {
          // Pass pagination state to decorator
            this.hitDecorator(item, data, decorator, {pageNo: currentPaginationState.page_no, restoreIndex: currentPaginationState.selected_index});
        }
        if (this.currentData['saveInS3'] && this.currentData.resouceDef && this.currentData.resouceDef.config && this.currentData.resouceDef.config.view_config && this.currentData.resouceDef.config.view_config[0]['url'] && data.resource && data.resource.length > 0 && data.resource[0].status == 'final') {
          let url = this.currentData.resouceDef.config.view_config[0]['url'];
          this.urlMaker(url, (url) => {
            this.currentData.selectedList.url = undefined;
            this.makeImageFromUrl(url);
          });
        }
        this.loader.hideSpinner();

        if (callback != null) {
          data['resourceName'] = resource;
          callback(data);
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback) {
          callback(false);
        }
      }
    )
  }
  else {
    this.hitDecorator(item, {}, decorator)
  }

}

// This function is used for compatibility with previous templates
setDataInsideForm(data) {
  if (data.templateId == undefined)
    data.template.template_id = data.template_id;
  else
    data.template.templateId = data.templateId;
  if (data.templateName == undefined)
    data.template.template_name = data.template_name;
  else
    data.template.templateName = data.templateName;
  if (data.templateType == undefined)
    data.template.template_type = data.template_type;
  else
    data.template.templateType = data.templateType;
  return data;
}
hitDecorator(item, data, decorator, obj:{pageNo?: number, restoreIndex?: number | null} = {pageNo: 0, restoreIndex: null}) {
  if (decorator && decorator.afterSubmitReq) {
    decorator.afterSubmitReq(item, data, undefined, (cb): any => {
      if (cb) {
        if (JSON.stringify(data) == '{}')
          this.alerts.success("")
        if (cb.redirect && this.route.snapshot.queryParams.returnUrl)
          this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl)
        else
          console.log(`hitDecorator calling filterClick with page: ${obj.pageNo}, index: ${obj.restoreIndex}`);
          this.filterClick(this.search, {pageNo: obj.pageNo, restoreIndex: obj.restoreIndex})
        // this.getHistory();
      }
    })
  } else {
    //this.alerts.success("Added Successfully");
    console.log(`hitDecorator (no decorator) calling filterClick with page: ${obj.pageNo}, index: ${obj.restoreIndex}`);
    this.filterClick(this.search, {pageNo: obj.pageNo, restoreIndex: obj.restoreIndex})
  }
  // this.getHistory();
}

  mobileRowClick(event: MouseEvent, entity: any) {
    const target = event.target as HTMLElement;
    if (target.closest('a')) {
      return;
    }
    if (this.utilService?.isMobile()) {
      this.currentData['selectedList'] = entity;
      if (this.currentData?.resouceDef?.rowClick) {
        this.onButtonClicked(this.currentData?.resouceDef?.rowClick);
      }
    }
  }

mobileEventCall(entity) {
  this.currentData['selectedList'] = entity;
  this.currentData.show = false;
}

viewDicom(data) {
  let obj = {
    data: data,
    config: {
      type: 'checkFromRes',
      datasource: {
        "application": "diagnostic",
        "resource": "radio",
        "args": "serviceRequestId:" + data.serviceRequestId + ",facility_id:" + data.facility_id,
        "queryId": "GET_PACS_IMAGE_ID_OR_URL"
      }
    }
  }
  if (this.currentData?.ehr_view) {
    obj.config.datasource['read_scope_level'] = 'account';
  }
  this.smartModalService.open(DiacomViewerComponent, {
    'data': obj

  }, 'Document', ModalSize.Lg).subscribe(
    data => { }, err => { }
  )
}

smartReport(entity, field) {
  let s_r = entity.smartReportUploadedDocumentId;
  this.currentData.selectedList.view_selected_config = {};
  this.currentData.selectedList.view_selected_config.type = 'pdf';
  let url = this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?path=' + s_r + '&application=dms';
  this.currentData.selectedList.url = undefined;
  this.baseService.getFileByUrl(url, false).subscribe((res: any) => {
    if (res) {
      this.printService.handleFileReponse({
        contentTypeChange: true,
        contentType: res.type,
        s3: true
      }, 'print', res);
    }
  });
}

markReportSeen(entity, field) {
  if (this.checkIconExpression(field, entity)) return;
  this.baseService.action({ serviceRequestId: entity.serviceRequestId }, "MARK_REPORT_AS_SEEN", "diagnostic", "observation").subscribe((res: any) => {
    if (res && res.errCode == -1) {
      this.alerts.error(res.message);
    } else if(res && res.errCode == 0){
      this.asideBarService.setRefresh(true);
    }
  });
}

getMedicationDetails() {
  if (this.currentPrescription && this.currentPrescription.hasOwnProperty('encounter_id') && this.currentPrescription.hasOwnProperty('uhId')) {
    this.loader.showSpinner();
    // returnlet filter= `encounter_id:Visit No-676,uhId:PARAS_1167`;
    let args = `facility_id:${this.currentPrescription.facility_id}`;
    let filter = `encounter_id:${this.currentPrescription.encounter_id},uhId:${this.currentPrescription.uhId}`;
    this.baseService.getData({ "args": args, "filter": `encounter_id:${this.currentPrescription.encounter_id},uhId:${this.currentPrescription.uhId}` }, "", "emr_medicationRequest", "emr", "GET_PAGE").subscribe((res: any) => {
      if (res.errCode == 0) {
        console.log("Resource medication ", res);
        if (res && res.resource && res.resource[0] && res.resource[0].hasOwnProperty('data') && res.resource[0]) {
          this.dialogRef.close({ data: res.resource[0].data });
        } else {
          this.alerts.info("No medication found with this prescription.")
        }
      } else {
        this.alerts.info("Error while getting prescription details.")
      }
      this.loader.hideSpinner();
    })
  }
}
_getAmountConfig(op_no: string, uhId: string, serviceRequestId: string, encounter_id: string, callback) {
    // let args = `op_no:${op_no},uhId:${uhId},serviceRequestId:${serviceRequestId},encounter_id:${encounter_id}`;
    let args = "";
    if(op_no!=undefined && op_no!="") {
      args = `op_no:${op_no},uhId:${uhId},serviceRequestId:${serviceRequestId}`;
    } else if(encounter_id!=undefined && encounter_id!="") {
      args = `uhId:${uhId},serviceRequestId:${serviceRequestId},encounter_id:${encounter_id}`;
    }
    this.baseService.get("check-due-pending", args, "observation", "diagnostic").subscribe((result: any) => {
      if (result.errCode == -1 ) {
        callback(result) // true
        //   cb(result.resource)
      }else{
        callback(result)
      }
    }, (err) => {
      callback([])
    })
  }
/**
 * Loads and displays PDF in the common-viewer's right-side PDF viewer
 * Mimics the functionality of diagnostic_report.ts eventHandler, capabilityClick, and bulkDownload
 * @param item - The diagnostic report item to print/view
 */
loadSinglePrint(item: any, pdfOrderView?: boolean): void {
  if (!item) {
    this.alerts.error("No item selected");
    return;
  }

  // First check amount config like in diagnostic_report.ts
  this.loader.showSpinner();
  this._getAmountConfig(item?.op_no, item?.uhId, item?.serviceRequestId, item?.encounter_id, (callback) => {
    if (callback != undefined && callback && callback.message != 'Success') {
      this.alerts.error("You can not download and view the report as bill is in due stage.");
      this.loader.hideSpinner();
      return;
    } else {
      // Use the same logic as diagnostic_report.ts eventHandler
      this.processPrintForViewer(item, pdfOrderView);
    }
  });
}
/**
 * Process print logic similar to diagnostic_report.ts eventHandler
 * @param printData - The item data
 */
private processPrintForViewer(printData: any, pdfOrderView?: boolean): void {
  let file: any = {
    "key": "id",
    "action": "print",
    "file_data": {
      "template": "diagnostic",
      "application": "",
      "resource": "observation",
      "args": this.baseService.buildDyanamicStr(
            `uhId:!!!uhId!!!,serviceItemCode:!!!serviceItemCode!!!,serviceRequestId:!!!serviceRequestId!!!,serviceType_code:!!!serviceType_code!!!,reportAction:print,ehrFacilityID:!!!facility_id!!!,primaryKeyIdentifier:!!!serviceRequestId!!!,op_no:!!!op_no!!!,encounter_id:!!!encounter_id!!!${pdfOrderView ? ',userPrint:Y' : ''}`,
            { data: printData }),
      "file_type": "pdf",
      "queryId": "GET_UPLOADED_DOCUMENT"
    }
  };

  // Apply the same conditional logic from diagnostic_report.ts eventHandler
  
  // Pathology Print Logic
  if (printData.serviceType_code == 'pathology' && printData.resultType != 'template' && printData.resultType != 'cryo-preservation' && printData.isOutsourced == false && printData.isMultiStage == false) {
    delete file.file_data.queryId;
    file.file_data.template = "diagnostic";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'pathology' && printData.resultType != 'template' && printData.resultType != 'cryo-preservation' && printData.isOutsourced == true) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  if (printData.serviceType_code == 'pathology' && printData.resultType != 'template' && printData.resultType != 'cryo-preservation' && printData.isMultiStage == true && printData.isOutsourced == false) {
    delete file.file_data.queryId;
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.template = "antibiotic";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'pathology' && printData.resultType == 'cryo-preservation' && printData.isMultiStage == false && printData.isOutsourced == false && !printData['profile_id']) {
    delete file.file_data.queryId;
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.template = "frozenDiagnostic";
    file.file_data.file_type = "pdf";
    file.file_data.args = `uhId:${printData['uhId']},serviceRequestId:${printData['serviceRequestId']},reportStatus:${printData['reportStatus']}, && primaryKeyIdentifier:${printData['serviceRequestId']},op_no:${printData['op_no']},encounter_id:${printData['encounter_id']},serviceType_code:${printData['serviceType_code']},userPrint:Y`;
          
  }

  if (printData.serviceType_code == 'pathology' && printData.resultType == 'template' && printData.resultType != 'cryo-preservation' && printData.isOutsourced == false) {
    delete file.file_data.queryId;
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  // Radiology Print Logic
  if (printData.serviceType_code == 'radiology' && printData.resultType != 'template' && !printData.uploadedDocumentId) {
    delete file.file_data.queryId;
    file.file_data.resource = "radio_provisioning_finalization";
    file.file_data.application = "diagnostic";
    file.file_data.template = "ris";
    file.file_data.file_type = "pdf";
    file.file_data.args = this.baseService.buildDyanamicStr(
            `uhId:!!!uhId!!!,serviceRequestId:!!!serviceRequestId!!!,reportStatus:!!!reportStatus!!!, && primaryKeyIdentifier:!!!serviceRequestId!!!,op_no:!!!op_no!!!,encounter_id:!!!encounter_id!!!,serviceType_code:!!!serviceType_code!!!${pdfOrderView ? ',userPrint:Y' : ''}`,
            { data: printData });
  }

  if (printData.serviceType_code == 'radiology' && printData.resultType == 'template' && !printData.uploadedDocumentId) {
    delete file.file_data.queryId;
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'radiology' && printData.uploadedDocumentId) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  // Cardiology Print Logic
  if (printData.serviceType_code == 'cardiology' && printData.isOutsourced == true) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  if (printData.serviceType_code == 'cardiology' && printData.isOutsourced == false && printData.resultType != 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "cardiology_provisioning_finalization";
    file.file_data.application = "diagnostic";
    file.file_data.template = "ris";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'cardiology' && printData.isOutsourced == false && printData.resultType == 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  // Pulmonology Print Logic
  if (printData.serviceType_code == 'pulmonology' && printData.isOutsourced == false && printData.resultType != 'template') {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "pulmonology_provisioning_finalization";
    file.file_data.application = "diagnostic";
    file.file_data.template = "ris";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'pulmonology' && printData.isOutsourced == true) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  if (printData.serviceType_code == 'pulmonology' && printData.resultType == 'template' && printData.isOutsourced == false) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  // Neurology Print Logic
  if (printData.serviceType_code == 'neurology' && printData.isOutsourced == false && printData.resultType != 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "neurology_provisioning_finalization";
    file.file_data.application = "diagnostic";
    file.file_data.template = "ris";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'neurology' && printData.isOutsourced == true) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  if (printData.serviceType_code == 'neurology' && printData.isOutsourced == false && printData.resultType == 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  // Nuclear Medicine Print Logic
  if (printData.serviceType_code == 'nuclear_medicine' && printData.isOutsourced == false && printData.resultType != 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "nuclear_medicine_provisioning_finalization";
    file.file_data.application = "diagnostic";
    file.file_data.template = "ris";
    file.file_data.file_type = "pdf";
  }

  if (printData.serviceType_code == 'nuclear_medicine' && printData.isOutsourced == true) {
    file.file_data.queryId = "GET_UPLOADED_DOCUMENT";
    file.file_data.resource = "observation";
    file.file_data.application = "diagnostic";
    file.file_data.file_type = "byte_array";
    delete file.file_data.template;
    this.capabilityClickForViewer(file);
    return;
  }

  if (printData.serviceType_code == 'nuclear_medicine' && printData.isOutsourced == false && printData.resultType == 'template') {
    delete file.file_data.queryId;
    file.file_data.resource = "template";
    file.file_data.application = "form-template-engine";
    file.file_data.template = "templateDiagnostic";
    file.file_data.file_type = "pdf";
  }

  // Handle the file for viewer display
  if (file.file_data.application != '') {
    this.handleFileForViewer(file, printData);
  } else {
    this.loader.hideSpinner();
  }
}

/**
 * Similar to capabilityClick but for viewer display
 * @param fileObj - File object configuration
 */
private capabilityClickForViewer(fileObj: any): void {
  if (fileObj.file_data.args) {
    let args = {
      "args": fileObj.file_data.args,
      "read_scope_level": "account",
    };

    this.baseService.getData(args, "", 'observation', 'diagnostic', "GET_UPLOADED_DOCUMENT").subscribe(res => {
      if (res.errCode != undefined && res.errCode == 0 && res.resource.length > 0) {
        this.bulkDownloadForViewer(res.resource[0]);
      } else {
        this.alerts.error(res.message);
        console.log("No such record found " + res.message);
        this.loader.hideSpinner();
      }
    });
  }
}

/**
 * Similar to bulkDownload but for viewer display instead of browser download
 * @param obj - Object containing document information
 */
private bulkDownloadForViewer(obj: any): void {
  let url = '/dms/api/v1/' + 'emrImage' + '/image-response-entity?path=' + obj.uploadedDocumentId;
  
  this.baseService.getFileByUrl(url, false).subscribe(res => {
    if (res) {
      if(res.type != 'application/pdf') {
        this.convertImageToPDF(res).then((data) => {
            this.setupPDFViewer(data, obj?.serviceItemName || 'Document');
        })
      } else {
        this.setupPDFViewer(res, res?.serviceItemName || 'Document');
      }
    } else {
      this.alerts.error('Failed to load document');
      this.loader.hideSpinner();
    }
  });
}

/**
 * Handle file for viewer display instead of printing
 * @param action - Action configuration
 * @param obj - Data object
 */
private handleFileForViewer(action: any, obj: any): void {
  if (action.file_data != undefined) {
    var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
    var fileObj = JSON.parse(JSON.stringify(action.file_data));
    
    fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
    fileObj.resource = this.baseService.buildDyanamicStr(fileObj.resource, obj);
    fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
    fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
    fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;

    // Add facility_id
    if (fileObj.args && obj?.facility_id) {
      fileObj.args = fileObj.args + ",facility_id:" + obj.facility_id;
    }

    // Instead of calling handleFile for printing, get the file for viewing
    this.baseService.handleFile(fileObj, async (fileData: any) => {
      if (!fileData) {
        this.alerts.error('Server error');
        this.loader.hideSpinner();
        return;
      }

      if (fileData.type === "application/json") {
        try {
          const response = await fileData.text();
          const parsedResponse = JSON.parse(response);
          if (parsedResponse.errCode === -1 && parsedResponse.message) {
            this.alerts.error(parsedResponse.message);
          }
          this.loader.hideSpinner();
        } catch (e) {
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      } else {
        // Set up PDF viewer with the received file data
        this.setupPDFViewer(fileData, key || 'Document');

      }
    });
  } else {
    console.error("Please provide File Data");
    this.loader.hideSpinner();
  }
}

/**
 * Set up the PDF viewer in the right panel of common-viewer
 * @param fileData - The PDF file data (Blob)
 * @param fileName - Name of the file
 */
private setupPDFViewer(fileData: Blob, fileName: string): void {
  try {
    // Create object URL for the PDF
    const url = URL.createObjectURL(fileData);
    const fileExtension = this.baseService.getExtensionbyMimeType(fileData.type);
    
    // Set up the selectedList for PDF viewing (similar to onClickSideList logic)
    this.currentData.selectedList = {
      url: url,
      urlBlob: fileData,
      urlFileType: fileExtension || '.pdf',
      urlFileName: fileName + (fileExtension || '.pdf'),
      view_selected_config: {
        type: 'pdf'
      }
    };
    
    // Show the viewer
    this.currentData.show = true;
    this.loader.hideSpinner();
    
    console.log('PDF loaded in viewer:', fileName);
  } catch (error) {
    console.error('Error setting up PDF viewer:', error);
    this.alerts.error('Failed to display PDF');
    this.loader.hideSpinner();
  }
}

/**
 * Converts an image blob (JPEG/PNG) to a PDF document
 * Uses pdf-lib to create a new PDF with the image embedded at full size
 * 
 * @param imageBlob - The image blob to convert (must be JPEG or PNG format)
 * @returns Promise<Blob> - A promise that resolves with the PDF blob
 * 
 * @throws Error if image type is not supported (only JPEG/PNG allowed)
 * 
 * The conversion process:
 * 1. Creates new PDF document
 * 2. Converts image blob to byte array
 * 3. Embeds image based on type (JPEG/PNG)
 * 4. Creates PDF page matching image dimensions
 * 5. Draws image on the page
 * 6. Returns PDF as blob
 */
async convertImageToPDF(imageBlob: Blob): Promise<Blob> {
  // Create new PDF document
  const pdfDoc = await PDFDocument.create();
  
  // Convert blob to base64
  const arrayBuffer = await imageBlob.arrayBuffer();
  const imageBytes = new Uint8Array(arrayBuffer);
  
  // Determine image type and embed accordingly
  let image;
  const imageType = imageBlob.type.toLowerCase();
  console.log('Image type:', imageType);
  if (imageType.includes('jpeg') || imageType.includes('jpg')) {
      image = await pdfDoc.embedJpg(imageBytes);
  } else if (imageType.includes('png')) {
      image = await pdfDoc.embedPng(imageBytes);
  } else {
      this.loader.hideSpinner();
      throw new Error('Unsupported image type. Only JPEG and PNG are supported.');
  }
  
  // Add a page with the image dimensions
  const page = pdfDoc.addPage([image.width, image.height]);
  
  // Draw the image on the page
  page.drawImage(image, {
      x: 0,
      y: 0,
      width: image.width,
      height: image.height,
  });
  
  // Save the PDF
  const pdfBytes = await pdfDoc.save();
  
  // Return as Blob
  return new Blob([pdfBytes], { type: 'application/pdf' });
}

hitSecondaryDataSource(item, index ?, show ?, versionCheck ?) {
  let pdfCondition = false
  if(eval(this.currentData?.['resouceDef']?.config?.pdfRestrictExpression) && this.currentData?.pdf_order_view){
      pdfCondition = true;
      if(this.currentData['pdfOrderViewEvent']){
      this.alerts.info('Result is in provisional stage');
      this.currentData['pdfOrderViewEvent'] = false;
      }
  }
  if (item && (item.selected_index == 0 || item.selected_index)) {
    this.pagination.selected_index = item.selected_index;
    this.activeValue = item.selected_index;
    this.savePaginationState();
  }
  // this.communicationService.setCommonViwerData$(item)
  if (index > 0 && this.currentData && this.currentData['resouceDef'] && this.currentData.resouceDef.resource && this.currentData.resouceDef.resource == "anc_registration") {
    this.hideEdit = true;//hide edit button for card except first
  } else this.hideEdit = false;

  let url = (this.route?.snapshot?.queryParams?.returnUrl) ? (this.route.snapshot.queryParams.returnUrl) : undefined
  if (url?.includes('dischargePatient') && this.currentData.cardData.encounter_id != item.encounter_id) {
    this.hideEdit = true
  } else {
    this.hideEdit = false
  }

  if (!versionCheck) {
    this.removeClass();
  }
  // pdf is true 
  let pdfView = pdfCondition?!pdfCondition:this?.currentData?.pdf_order_view
  if (item  && pdfView && ((pdfView && this.currentResource === 'ip_diagnostic_report') || (this?.userRole == 'Patient' && this.currentResource === 'patient_diagnostic_report'))) {
      this.loader.showSpinner();
      console.log("Condition check:", {
        pdf_order_view: this?.currentData?.pdf_order_view,
        currentResource: this.currentResource,
        userRole: this?.userRole
      });
      this.loadSinglePrint(item, this?.currentData?.pdf_order_view);
      this.savePaginationState();
      return; 
  }
  // pdf is false 
  var dataSourceConfig = this.currentData['resouceDef'].config.view_config[0]
  this.loader.showSpinner();
  this.currentPrescription = item;
  this.getAmountConfigValue = true
  if (dataSourceConfig.datasource) {
    if (dataSourceConfig.expression == undefined || eval(dataSourceConfig.expression)) {
      if (dataSourceConfig.datasource.args != undefined && dataSourceConfig.datasource.args.indexOf('!!!') != -1) {
        var args = this.baseService.buildDyanamicStr(dataSourceConfig.datasource.args, { data: item })
      }
      var data = { args: args };
      if (this.currentData.ehr_view)
        data['read_scope_level'] = 'account';
      else if (data['read_scope_level'] != undefined)
        delete data['read_scope_level'];
      this.currentData.gridCardData = undefined;//115489 
      this.baseService.getData(data, '', dataSourceConfig.datasource.resource, dataSourceConfig.datasource.application, dataSourceConfig.datasource.queryId).subscribe(subRes => {
        if (subRes && subRes.resource && subRes.resource.length > 0) {
          delete subRes.resource[0].id;
          delete subRes.resource[0].status;
          if (item != undefined && item.labServiceType != undefined && item.labServiceType == "group" && subRes.resource.length > 1 && subRes.resource[0].tests != undefined) {
            for (let i = 1; i < subRes.resource.length; i++) {
              subRes.resource[0].tests = subRes.resource[0].tests.concat(subRes.resource[i].tests)
            }
          }
          subRes?.resource?.forEach(element => {
            element['showPrint'] = item['showPrint']
            if(element.tests != undefined && element.tests.length > 0){
              element.tests.forEach(el => {
                  el['showPrint'] = item['showPrint']
              });
            }
          });
          this.currentData.gridCardData = subRes
          this.onClickSideList({ ...item, ...subRes.resource[0] }, show);
          //this.noObservationFound = false; 
        }
        else {
          this.currentData['selectedList'] = item;
          this.noObservationFound = true
        }
        this.loader.hideSpinner()
      })
    }
    else {
      this.currentData['selectedList'] = item;
      this.noObservationFound = true;
      this.loader.hideSpinner()
    }
  }
  else {
    this.onClickSideList(item, show, versionCheck);
    this.loader.hideSpinner()
  }

  if (this.currentData.scrollToView != undefined && this.currentData.scrollToView && document.getElementById("scrollTestLab ") != null) { // scroll grid data to view
    setTimeout(() => { document.getElementById("scrollTestLab ").style.paddingTop = `${window.scrollY > 200 ? window.scrollY - 200 : 0}px`; });
  }
  this.savePaginationState();
}

setVersionControl(item) {
  if (this.currentData && this.currentData.resouceDef && this.currentData.resouceDef.list && this.currentData.resouceDef.list.APIresource && this.currentData.resouceDef.list.APIresource.version_datasource) {
    let ds = this.currentData.resouceDef.list?.APIresource.version_datasource;
    let args = this.baseService.buildDyanamicStr(this.currentData.resouceDef.list?.APIresource.version_datasource.args, { data: item });
    let filter = this.baseService.buildDyanamicStr(this.currentData.resouceDef.list?.APIresource.version_datasource.filter, { data: item });
    this.getData(ds.query_id, args, ds.resource, ds.application, filter, (data) => {
      if (data)
        this.currentData.VersionList = data;
    });
  }
}

  async getData(queryId, args, resource, application, filter, callback ?) {
  // (queryId, args, resource = null, application?: any, filter?: any, responseType?: any, config?: any)
  await this.baseService.get(queryId, args, resource, application, filter).toPromise().then(data => {
    if (data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
      if (callback) {
        callback(data.resource);
      }
    }
    else if (callback) {
      callback(false);
    }
  })
}

applyQuickFilter(event) {
  let hitApi = false;
  var filterObject = {}
  this.filter.pseudoFilter.split(",").forEach(e => {
    var d = e.split(":")
    filterObject[d[0]] = d[1]
  })
  if (this.config.filterConfig != undefined && this.config.filterConfig.FilterName != undefined) {
    if (event.data != undefined && this.config.filterConfig.data != undefined && event.data == this.config.filterConfig.data) {
      delete this.config.filterConfig['FilterName']
      delete this.config.filterConfig['data']
      if (this.config.filterConfig.keysAdded != undefined && this.config.filterConfig.keysAdded.length > 0) {
        this.config.filterConfig.keysAdded.forEach(el => {
          if (filterObject[el] != undefined) delete filterObject[el]
        });
      }
      delete this.config.filterConfig['keysAdded'];
      this.default_quick_filter.executed = undefined;
    } else {
      if (event.data != undefined) {
        this.config.filterConfig['FilterName'] = event.name
        this.config.filterConfig['data'] = event.data
        for (let f in event.data) {
          if (event.data[f].type == "daterangepicker") {
            let date = DateRangeConfig[event.data.daterangefilter.value]();
            if (filterObject["FROM"] == undefined && filterObject["TO"] == undefined)
              this.config.filterConfig['keysAdded'] = ["FROM", "TO"]
            filterObject["FROM"] = date[0]
            filterObject["TO"] = date[1]
          }
          if (event.data[f].type == "dropdown") {
            filterObject[f] = event.data[f].value
          }
        }
        var dataAsString = Object.keys(filterObject).map(function (d: any) { return d + ":" + filterObject[d] })
        var output = dataAsString.join(',');
        // this.default_quick_filter.executed = output;
        hitApi = true;
        this.hitApiUsingFilter(output)
      }
    }
  }
  else {
    if (event.data != undefined) {
      this.config.filterConfig['FilterName'] = event.name
      this.config.filterConfig['data'] = event.data
      for (let f in event.data) {
        if (event.data[f].type == "daterangepicker") {
          let date = DateRangeConfig[event.data.daterangefilter.value]();
          if (filterObject["FROM"] == undefined && filterObject["TO"] == undefined)
            this.config.filterConfig['keysAdded'] = ["FROM", "TO"]
          filterObject["FROM"] = date[0]
          filterObject["TO"] = date[1]
        }
        if (event.data[f].type == "dropdown") {
          filterObject[f] = event.data[f].value
        }
      }
      var dataAsString = Object.keys(filterObject).map(function (d: any) { return d + ":" + filterObject[d] })
      var output = dataAsString.join(',');
      if (this.default_quick_filter.selected && this.default_quick_filter.data.name != undefined)
        this.default_quick_filter.executed = output;
      hitApi = true;
      this.hitApiUsingFilter(output)
    }
  }
  if (!hitApi) {
    var dataAsString = Object.keys(filterObject).map(function (d: any) { return d + ":" + filterObject[d] })
    var output = dataAsString.join(',');
    this.hitApiUsingFilter(output)
  }
}

doSearch(event) {
  console.log('doSearch', event)
  if (this.config.filterConfig && this.config.filterConfig.FilterName != undefined) {
    this.config.filterConfig.FilterName = ''
    delete this.config.filterConfig['FilterName']
    delete this.config.filterConfig['data']
    delete this.config.filterConfig['keysAdded']
  }
  this.hitApiUsingFilter(event, {resetPagination: true})
}
displayFilter() {
  this.currentData['filterBlock'].default_open = !this.currentData['filterBlock'].default_open
}

getDataFn(event) {
  console.log('getDataFn', event)
  if (event.type == 'default_filter') {
    if (this.default_quick_filter.selected && this.default_quick_filter.data.name != undefined) {
      this.filter.pseudoFilter = this.filterService.removeDuplicateKeysFromString({ "filter": event.obj.form });
      this.applyQuickFilter(this.default_quick_filter.data)
    } else {
      this.hitApiUsingFilter(event.obj.form, {resetPagination: false})
    }
  } else if (event.type == 'filter_save') {
    this.saveFilterData(event.obj);
  }
}

filterClick(event, obj:{pageNo?: number, restoreIndex?: number | undefined} = {pageNo: 0, restoreIndex: undefined}) {
  if (typeof event == 'object') {
    this.search = event.value
    this.complex_search_value = event
  } else {
    this.search = event;
    this.complex_search_value = event
  }
  this.pagination.page_no = obj.pageNo;
  console.log('doSearch', event)
  this.filter.filter = this.filter.filter == '' ? this.filter.pseudoFilter : this.filter.filter;
  let datasource = this.checkGetAPI()
  if (datasource)
    datasource.search = this.search
  this.getHistory(datasource, null, {restoreIndex: obj.restoreIndex})
}

hitApiUsingFilter(filter, obj:{resetPagination?: boolean | undefined} = {resetPagination: false}) {
  if (obj.resetPagination) {
    // ALWAYS reset pagination for filter/search operations
    this.pagination.page_no = 0;
    this.pagination.selected_index = 0;
    this.activeValue = 0;
    console.log(`Pagination reset due to filter/search operation`);
  } else {
    // Try to restore pagination for tab switching scenarios
    const wasRestored = this.ensurePaginationRestored();
    if (!wasRestored) {
      this.pagination.page_no = 0;
      this.pagination.selected_index = 0;
      this.activeValue = 0;
      console.log(`Pagination reset (no state to restore)`);
    } else {
      console.log(`Pagination preserved (state was restored)`);
    }
  }
  this.filter.filter = this.filterService.removeDuplicateKeysFromString({ "filter": filter });
  let datasource = this.checkGetAPI();
  this.getHistory(datasource)
}
saveFilterData(obj) {
  this.getTableConfig((saveData) => {
    saveData = (saveData) ? saveData : {};
    saveData["filter__"] = (saveData["filter__"] == undefined) ? [] : saveData["filter__"];
    var found = false;
    let index = 0
    if (obj.key != undefined) {
      for (index = 0; index < saveData["filter__"].length; index++) {
        var filter = saveData["filter__"][index];
        if (filter.key == obj.key) {
          found = true;
          break;
        }
      }
    }
    if (found) {
      saveData["filter__"][index] = obj;
    } else {
      saveData["filter__"].push(obj);
    }
    this.saveTableConfigData(saveData, () => {
      this.getSavedFilter();
    });
  });
}
saveTableConfigData(data, callback: any = false) {
  var key = this.config.saveKey;
  this.preferenceService.saveTableConfigData(key, data, callback);
}
resetFilter(event) {
  this.filter.filter = "";
  if (this.config.filterConfig && this.config.filterConfig.FilterName != undefined) {
    this.config.filterConfig.FilterName = ''
    delete this.config.filterConfig['FilterName']
    delete this.config.filterConfig['data']
    delete this.config.filterConfig['keysAdded']
  }
  // Reset pagination when clearing filters
  this.pagination.page_no = 0;
  this.pagination.selected_index = 0;
  this.activeValue = 0;
  console.log('Filter reset - pagination reset');

  this.getHistory();
}

checkGetAPI() {
  if (this.currentData['resouceDef'] && this.currentData['resouceDef']?.list?.hasOwnProperty('datasourceConditions')) {
    let datasource = ""
    let datasourceConditionExpression = ""
    this.currentData['resouceDef']?.list?.datasourceConditions.forEach(elem => {
      if (this.filter.filter.includes(elem.expression)) {
        datasource = elem.datasource
        datasourceConditionExpression = elem.expression
      }
    });
    // let datasource = this.currentData['resouceDef']?.list?.datasourceConditions.find(elem => (this.filter.filter.includes(elem.expression)))?.datasource;
    if (this.currentData['filterBlock'].remove_filter_after_api_check) {
      this.filter.pseudoFilter = this.filter.filter;
      if (datasourceConditionExpression) {
        this.filter.filter = this.filter.filter.replace(datasourceConditionExpression, "")
      } else {
        this.filter.filter = '';
      }
    }
    if (datasource)
      return datasource
    else
      return this.currentData?.APIResource?.datasource
  }
  else
    return this.currentData?.APIResource?.datasource
}

ngOnDestroy() {
  this.asideBarService.removeComponent();
  if (this.serVal != undefined && this.serVal.unsubscribe != undefined)
    this.serVal.unsubscribe();
  this.listenToKeyboard = !this.listenToKeyboard;

  this.paginationInitialized = false;
  this.paginationRestoredFor = null;
  if (this.currentData?.selectedList?.url) {
    URL.revokeObjectURL(this.currentData.selectedList.url);
  }
  if (this.currentData?.selectedList) {
    this.currentData.selectedList.urlBlob = null;
    this.currentData.selectedList.url = null;
  }
  this.printPopupSubscription.unsubscribe();
  this.pageRefreshSubscription.unsubscribe();
  this.closeBtnSubscription.unsubscribe();
}

removeClass() {
  let child = this.elementRef.nativeElement.getElementsByClassName('doc-view-list');
  for (let cl of child) {
    cl.classList.remove("doc-active-tab");
  }
}

getGridCardFields(gridSource) {
  if (gridSource == 'self') {
    this.currentData.gridCardFields = this.currentData.fields
    this.currentData.gridConfig = this.currentData['resouceDef'].config
  }
  else {
    this.baseService.getResourceDef(gridSource, (res) => {
      if (res) {
        this.currentData.gridCardFields = res.list.fields;
        this.currentData.gridConfig = res.config;
        if (this.currentData.resouceDef != undefined && this.currentData.resouceDef.config != undefined && this.currentData.resouceDef.config.card_view != undefined && this.currentData.resouceDef.config.card_view != 'false') {
          this.cardViewChange(this.secondListView)
        }
        this.getDecorator();
        if (res.list && res.list.gridButtons != undefined) {
          if (this.currentData.gridCardFields.find(elem => (elem.name == 'gridButton')) == undefined) {
            res.list.gridButtons.name = "gridButton";
            this.currentData.gridCardFields.push(res.list.gridButtons);
          }
        }
        this.currentData.gridCardFields = this.rolePermissionService.getAllowedContextMenu(this.currentData.gridCardFields, res.capability, res.resource);
      }
    })
  }
  this.getDecorator();
}

getDecorator() {
  if (this.currentData.gridConfig != undefined && this.currentData.gridConfig.decorator != undefined && this.currentData.gridConfig.decorator != '')
    this.currentData.gridDecorator = this.baseService.initDecorator(this.currentData.gridConfig.decorator, this.route, this.injector);
}

  checkExpressionForAdd() {
    if (this.currentData['resouceDef'].config.add_required != undefined && this.currentData['resouceDef'].config.add_required_expression != undefined) {
      //177323 check search because when we search add button validation is not required
      if (this.search == undefined || this.search == '') {
        if (this.currentData['list'] && this.currentData['list'].length > 0) {
          var expression = this.currentData['resouceDef'].config.add_required_expression;
          var filteredData = this.currentData['list'].filter(item => eval(expression) != -1);

          if (this.currentData['list'][0].status == "final" && this.currentData != undefined && this.currentData['resouceDef'] != undefined && this.currentData.resouceDef.resource != undefined && this.currentData.resouceDef.resource == "anc_registration")
            return true;
          else if (filteredData != undefined && filteredData.length > 0)
            return false;
          else
            return true;
        } else
          return true;
      }
    } else
      return true;
  }

buttonAction(event) {
  console.log(event);
  if (event != undefined && event.actionType != undefined && event.actionType.action == "print" && event?.$event?.ctrlKey) {
    event.actionType.action = "print-async";
  }
  if (event.data != undefined && this.currentData.ehr_view != undefined && this.currentData.ehr_view)
    event.data['ehr_view'] = this.currentData.ehr_view
  if (this.currentData.gridDecorator && this.currentData.gridDecorator.buttonAction)
    this.currentData.gridDecorator.buttonAction(event)
}
eventHandler(item, field) {
  // in mobile view on type event click - decorator was undefined bz setasideview mthod i not call in case of mobile
  this.onClickSideList(item);
  setTimeout(() => {
    if ((this.currentData.gridDecorator && this.currentData.gridDecorator.eventHandler) || (this.currentData.decorator && this.currentData.decorator.eventHandler)) {
      let decorator = this.currentData.gridDecorator ? this.currentData.gridDecorator : this.currentData.decorator;
      decorator.eventHandler(item, field);
    }
  })
}
listResource() {
  if (this.route.snapshot.queryParams.returnUrl)
    this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl)
}
checkNavigationExist(type) {
  return this.rolePermissionService.checkAccessPermission(type, this.currentResource)
}
checkExpression(field, entity) {
  if (field.expression) {
    var item = entity;
    return eval(field.expression)(item);
  } else
    return true
}

checkIconExpression(field, entity) {
  if (field.iconExpression) {
    var item = entity;
    return eval(field.iconExpression)(item);
  } else
    return true
}

getStyle(field, entry) {
  if (field.styleFormat) {
    var color = eval(field.styleFormat)(entry);
    return { "color": color }
  }
}

versionChange(e) {
  if (e == '') {
    this.cancel_button_hide = false
  } else {
    this.cancel_button_hide = true
  }
  let data = this.currentData.VersionList.find(x => x.id === e);
  if (data) {
    this.hitSecondaryDataSource(data, "", "", true);
  }

}

cardViewChange(e) { // switch between card and grid view
  if (e == undefined) {
    e = this.currentData.gridConfig['activeField']
  }
  if (e == "table") {
    this.currentData.gridConfig['tile'] = false
    this.currentData.gridConfig['table'] = true
    this.currentData.gridConfig['activeField'] = "table"
    this.secondListView = "table"
    this.currentData.selectedList.view_selected_config.type == 'gridAbc'
    setTimeout(() => { // gives time for dhs-data-grid to refresh
      this.currentData.selectedList.view_selected_config.type == 'grid'
    })
  } else if (e == "tile") {
    this.currentData.gridConfig['tile'] = true
    this.currentData.gridConfig['table'] = false
    this.currentData.gridConfig['activeField'] = "tile"
    this.secondListView = "tile"
    this.currentData.selectedList.view_selected_config.type == 'gridAbc'
    setTimeout(() => {  // gives time for dhs-data-grid to refresh
      this.currentData.selectedList.view_selected_config.type == 'grid'
    })
  }
}

archivalRedirection() {
  let info = {
    "base": "diagnostic_reports",
    "url": "/account-management/archival_data"
  };
  this.router.navigate([info.url], { queryParams: { returnUrl: this.router.url, key: info.base, uhId: this.currentData.cardData.uhId } });
}

onBulkActionClicked(action_obj: Object) {
  console.log(action_obj);
  if (this?.currentData?.gridDecorator?.processBulkAction) {
    this.currentData.gridDecorator.processBulkAction(action_obj, undefined, undefined, undefined, undefined);
  }
}


onlyEditForDischargePatientList(resouceDef) {
  let url = (this.route?.snapshot?.queryParams?.returnUrl) ? (this.route.snapshot.queryParams.returnUrl) : undefined
  if (url?.includes('dischargePatient') && resouceDef?.config?.addDischarge == false) {
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:add_document_after_discharge", "facility_config_mapping", "facility-management").subscribe(data => {
      let currentData = JSON.parse(sessionStorage.getItem('currentData'))
      let timeTillDocumentWillsee;
      if (data.resource?.[0]?.config_value) {
        timeTillDocumentWillsee = parseInt((currentData?.dischargeDate) ? (currentData.dischargeDate) : (currentData.dischargeIntimationDateAndTime)) + parseInt(data.resource?.[0]?.config_value) * 60 * 60 * 1000
      }
      let currentTime = new Date().getTime()
      if (data.errCode == 0 && data.resource?.length > 0 && timeTillDocumentWillsee > currentTime) {
        // if (resouceDef.config.actionBtnEditView) {
          // resouceDef.config.action_buttons = resouceDef.config.action_buttons.filter((x) => x.class == 'fa fa-edit' || x.class == 'fa fa-print' || x.class == 'fa fa-info-circle' || x.class == 'fa fa-copy')
          // if (resouceDef.config.action_buttons.length > 0) {
          //   resouceDef.config.action_buttons.forEach(element => {
          //     if (element.class == 'fa fa-edit') {
          //       element.expression = "this.currentData.cardData['encounter_id'] == item['encounter_id']"
          //     }
          //   });
          // }
        // }
      } else {
        this.dischargePatientList = true
        resouceDef.config.action_buttons = resouceDef.config.action_buttons.filter((x) => x.class == 'fa fa-print' || x.class == 'fa fa-info-circle')
      }
    });
  }
}


  toggleMenu(event: Event, menu: HTMLElement) {
    event.stopPropagation(); // prevent immediate close
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      menu.classList.add('show');
    } else {
      menu.classList.remove('show');
    }
  }

  checkExpandableFeatureEnabled() {
    if (this.utilService.isMobile()) {
      let tabName = ["template_assessment","template_assessment_final"]
      if(this.currentData.resouceDef.resource && this?.currentData?.resouceDef?.list?.mobile_card_view_Field)
      this.isExpandableField = tabName.includes(this.currentData.resouceDef.resource)
    }
  }

saveUserDepartment() {
  if (this.currentDoctor) {
    this.currentData.cardData = { ...this.currentData.cardData, ...this.currentDoctor }
  }
}

/*================ START: CUMULATIVE PRINTING LOGIC FOR PRESCRIPTION HISTORY =================*/

  reHydrateSelectedItemsForPrint(): void {
    // Sync cumulative selection state: Check if loaded items are already in the selectedItemsForCumulativePrint array (by ID)
    if (this?.selectedItemsForCumulativePrint?.length > 0 && this?.currentData['list']?.length > 0) {
      this.currentData['list'].forEach(item => {
        // Find index of item in global array with the same ID
        const index = this?.selectedItemsForCumulativePrint?.findIndex(selected => selected.id == item.id);
        
        if (index > -1) {
          item.selected = true; // Visually select the checkbox
          this.selectedItemsForCumulativePrint[index] = item;
        }
      });
    }
  }

  /**
   * Handles checkbox change event
   * @param entity - The entity/item that was checked/unchecked
   * @param index - The index of the item in the list
   * @param event - The change event
   */
  onCheckboxChange(entity: any, index: number, event: any) {
    if (event.target.checked) {
      // Check if adding this item would exceed the limit
      if (this.selectedItemsForCumulativePrint.length >= this.MAX_SELECTION_LIMIT) {
        // Revert the checkbox
        event.target.checked = false;
        entity.selected = false;
        
        // Show alert
        this.alerts.error(`Maximum ${this.MAX_SELECTION_LIMIT} records can be selected for printing`);
        return;
      }

      // Add to selected items if not already present
      if (!this.selectedItemsForCumulativePrint.includes(entity)) {
        this.selectedItemsForCumulativePrint.push(entity);
      }
    } else {
      // Remove from selected items
      const position = this.selectedItemsForCumulativePrint.indexOf(entity);
      if (position > -1) {
        this.selectedItemsForCumulativePrint.splice(position, 1);
      }
    }
    console.log('Selected items:', this.selectedItemsForCumulativePrint);
  }

  /**
   * Get count of selected checkboxes
   */
  getSelectedCount(): number {
    return this.selectedItemsForCumulativePrint.length;
  }

  /**
   * Check if all items are selected
   */
  isAllSelected(): boolean {
    if (!this.currentData.list || this.currentData.list.length === 0) {
      return false;
    }
    return this.currentData.list.every(item => item.selected === true);
  }

  /**
   * Toggle select all checkboxes
   */
  /**
   * Toggle select all checkboxes
   */
  toggleSelectAll(event: any): void {
    const isChecked = event.target.checked;
    
    if (this.currentData.list && this.currentData.list.length > 0) {
      if (isChecked) {
        // Calculate how many more items we can add
        let availableSlots = this.MAX_SELECTION_LIMIT - this.selectedItemsForCumulativePrint.length;
        
        if (availableSlots <= 0) {
          // Limit reached, cannot select more
          event.target.checked = false;
          this.alerts.error(`Maximum ${this.MAX_SELECTION_LIMIT} records can be selected for printing`);
          return;
        }

        let limitReached = false;

        this.currentData.list.forEach((item) => {
          // If item is already selected (visually or in global list), preserve it and skip adding
          if (item.selected || this.selectedItemsForCumulativePrint.includes(item)) {
            item.selected = true; // Sync UI state just in case
            return;
          }
          
          // Try to select vacent items if space is available
          if (availableSlots > 0) {
            item.selected = true;
            this.selectedItemsForCumulativePrint.push(item);
            availableSlots--;
          } else {
            limitReached = true;
            item.selected = false;
          }
        });
        
        if (limitReached) {
          this.alerts.info(`Selection limited to ${this.MAX_SELECTION_LIMIT} items.`);
          // Checkbox will naturally update via [checked]="isAllSelected()" binding on next cycle
        }

      } else {
        // Uncheck: Deselect only visible items on current page (preserve other pages' selections)
        this.currentData.list.forEach((item) => {
          if (item.selected) {
            item.selected = false;
            // Remove from global list
            const index = this.selectedItemsForCumulativePrint.indexOf(item);
            if (index > -1) {
              this.selectedItemsForCumulativePrint.splice(index, 1);
            }
          }
        });
      }
    }
    
    console.log('Selected items count:', this.selectedItemsForCumulativePrint.length);
  }

  /**
   * Orchestrates cumulative printing of multiple selected prescription/report items
   * Fetches PDF blobs for each item, merges them, and opens in print dialog
   * 
   * @returns Promise<void>
   * 
   * Flow:
   * - Validates at least one item is selected
   * - Sequentially fetches PDF blobs for all selected items
   * - Tracks failed items and continues with successful ones
   * - Merges all PDFs into single document
   * - Opens merged PDF in new browser window for printing
   * - Handles errors gracefully with user alerts
   */
  async printSelectedItems(): Promise<void> {
    if (this.selectedItemsForCumulativePrint.length === 0) {
      this.alerts.info('Please select at least one item to print');
      return;
    }

    console.log('Starting cumulative print for', this.selectedItemsForCumulativePrint.length, 'items');
    // this.loader.showSpinner();

    const pdfBlobs:  Blob[] = [];
    const failedItems: any[] = [];

    this.isCumulativePrinting = true;

    try {
      // Fetch all PDFs sequentially
      for (const item of this.selectedItemsForCumulativePrint) {
        try {
          console.log('Fetching PDF for item:', item.prescriptionNo || item.id);
          
          // Use the modified onClickSideList with returnBlob flag
          const blob = await this.fetchPDFBlobForPrint(item);
          
          if (blob && blob instanceof Blob) {
            console.log('Successfully fetched PDF blob:', blob.type, blob.size);
            pdfBlobs.push(blob);
          } else {
            console.warn('Invalid blob received for:', item.prescriptionNo || item.id);
            failedItems.push(item);
          }
        } catch (error) {
          console.error('Error fetching PDF for item:', item.prescriptionNo || item.id, error);
          this.isCumulativePrinting = false;
          return null;
        }
      }

      this.isCumulativePrinting = false;

      // Check if we got any PDFs
      if (pdfBlobs.length === 0) {
        // this.loader.hideSpinner();
        this.alerts.error('Failed to load any PDFs. Please try again.');
        return;
      }

      // Show warning if some items failed
      if (failedItems.length > 0) {
        const failedIds = failedItems.map(item => item.prescriptionNo || item.id).join(', ');
        this.alerts.info(`Failed to load ${failedItems.length} item(s): ${failedIds}.  Proceeding with ${pdfBlobs.length} successful item(s).`);
      }

      // Merge PDFs
      console.log('Merging', pdfBlobs.length, 'PDFs.. .');
      const mergedBlob = await this.mergePDFBlobs(pdfBlobs);
      
      // Open print dialog
      const objectUrl = URL.createObjectURL(mergedBlob);
      window.open(objectUrl, '_blank');

      // Deselect items to update UI checkboxes
      this.selectedItemsForCumulativePrint.forEach(item => {
        item.selected = false;
      });

      this.selectedItemsForCumulativePrint = [];

    } catch (error) {
      this.isCumulativePrinting = false;
      console.error('Error in cumulative print:', error);
      this.alerts.error('An error occurred while preparing documents for print');
    } finally {
      // this.loader.hideSpinner();
    }
  }

  /**
   * Merges multiple PDF blobs into a single PDF document
   * Sequentially combines all pages from input PDFs into one output file
   * 
   * @param blobs - Array of PDF blob objects to merge
   * @returns Promise<Blob> - Merged PDF blob ready for download/print
   * @throws Error if merge operation fails
   * 
   * Process:
   * - Creates new PDF document
   * - Iterates through each blob, loads PDF data
   * - Copies all pages to merged document
   * - Returns final PDF as Blob
   * - Gracefully handles individual PDF failures
   */
  async mergePDFBlobs(blobs: Blob[]): Promise<Blob> {
    try {
      // Create a new PDF document
      const mergedPdf = await PDFDocument.create();

      // Process each blob
      for (const blob of blobs) {
        try {
          // Convert blob to array buffer
          const arrayBuffer = await blob.arrayBuffer();
          
          // Load the PDF from array buffer
          const pdf = await PDFDocument.load(arrayBuffer);
          
          // Copy all pages from this PDF to merged PDF
          const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          copiedPages.forEach((page) => {
            mergedPdf.addPage(page);
          });
          
          console.log(`Added ${copiedPages.length} pages from PDF`);
        } catch (error) {
          console.error('Error processing PDF blob:', error);
          // Continue with other PDFs even if one fails
        }
      }

      // Save the merged PDF
      const mergedPdfBytes = await mergedPdf.save();
      
      // Create and return blob
      return new Blob([mergedPdfBytes], { type: 'application/pdf' });
    } catch (error) {
      console.error('Error merging PDFs:', error);
      throw new Error('Failed to merge PDF documents');
    }
  }

  /**
   * Fetches the document blob for a given list item to be used for printing or viewing.
   *
   * This function inspects the item's view configuration (image, pdf, form, grid, etc.),
   * evaluates any expressions required to determine the correct URL/source, and then
   * requests the appropriate file from DMS, S3, print-engine or generated URLs.
   *
   * Behavior summary:
   * - Supports image, pdf, form and grid view types with several sub-cases (S3, DMS, template URLs).
   * - Safely attempts to evaluate expressions found in view configuration; falls back with warnings.
   * - Builds dynamic URLs via baseService.buildDyanamicStr when needed.
   * - For 'form' type returns a JSON blob; for images and PDFs returns the binary Blob.
   * - Resolves with the Blob when successful; rejects with an Error when no valid source is found
   *   or a network/processing error occurs.
   *
   * @param {any} list - The item describing the document to fetch (contains view_config, document_id, s3, etc.)
   * @returns {Promise<Blob>} Promise that resolves with the document Blob or rejects with an error.
   */
  async fetchPDFBlobForPrint(list: any): Promise<Blob> {
    return new Promise(async (resolve, reject) => {
      try {
        const processingItem = { ...list };
        // Create 'item' variable for eval context (used throughout)
        const item = processingItem;

        // ============================================================
        // CONDITION 1: Amount Config Check (if enabled)
        // ============================================================
        if (this?.getAmountConfigValue) {
          this.getAmountConfigValue = false;
          try {
            await new Promise<void>((resolveAmount, rejectAmount) => {
              this.GetAmountConfig(processingItem);
              resolveAmount(); // Continue regardless of amount check
            });
          } catch (err) {
            console.warn('Amount config check failed, continuing... ', err);
          }
        }

        // ============================================================
        // CONDITION 2: Version Control Handling
        // ============================================================
        if (this.currentData?.resouceDef?.config?.definalize != undefined && 
            !processingItem?.versionCheck && 
            processingItem?.partOf != undefined) {
          this.currentData['hideDropdown'] = false;
          this.currentData.versionVal = '';
          this.setVersionControl(processingItem);
        }

        if (!processingItem?.partOf) {
          this.currentData['hideDropdown'] = true;
        }

        // ============================================================
        // CONDITION 3: Get View Configuration
        // ============================================================
        let config: any[] = [];

        if (this?.currentData?.['resouceDef']?.config?.view_config?.length > 0) {
          config = this?.currentData['resouceDef']?.config?.view_config?.filter(data => {
            // Create eval context variables
            const item = processingItem;
            const self = this;
            
            let pdfOrderView = data?.pdfOrderView;
            if (this?.currentData?.pdf_order_view) {
              // Keep all if pdf_order_view is true
            } else { 
              pdfOrderView = true; 
            }
            
            try {
              if (data?.expression != undefined) {
                return eval(data?.expression);
              } else if (pdfOrderView != undefined) {
                return eval(pdfOrderView);
              } else {
                return true;
              }
            } catch (e) {
              console. warn('Expression evaluation failed:', data.expression || pdfOrderView, e);
              return false;
            }
          });
        }

        // ============================================================
        // CONDITION 4: Handle Special list.view_config Array
        // ============================================================
        if ((!config || config?.length === 0) && processingItem?.view_config) {
          config = processingItem?.view_config;
        }

        if (!config || config?.length === 0) {
          reject(new Error('No valid view config found'));
          return;
        }

        processingItem['view_selected_config'] = config[0];

        // ============================================================
        // CONDITION 5: Dynamic Key Resolution
        // ============================================================
        let key = 'documentId'; // default
        try {
          if (processingItem['view_selected_config']?.dynamic_key != undefined) {
            key = eval(processingItem['view_selected_config']?.dynamic_key);
          } else if (processingItem['view_selected_config']?.key != undefined) {
            key = processingItem['view_selected_config']?.key;
          }
        } catch (e) {
          console.warn('Dynamic key evaluation failed, using default:', e);
        }

        // ============================================================
        // CONDITION 6: IMAGE TYPE HANDLING
        // ============================================================
        if (processingItem['view_selected_config']['type'] === 'image') {
          let shouldProcessImage = true;
          
          // Check expression if exists
          try {
            if (processingItem['view_selected_config']?.expression != undefined) {
              shouldProcessImage = eval(processingItem['view_selected_config']?.expression);
            }
          } catch (e) {
            console.warn('Image expression check failed:', e);
            shouldProcessImage = false;
          }

          if (shouldProcessImage) {
            // Handle string documentId → wrap in array
            if (typeof (processingItem[key]) == 'string') {
              processingItem['documentIds'] = [{ "documentId": processingItem[key] }];
            } 
            // Handle viewKey evaluation
            else if (config[0]?.viewKey != undefined) {
              try {
                const viewKeyResult = eval(config[0]?.viewKey);
                if (typeof viewKeyResult == 'string') {
                  processingItem['documentIds'] = [{ "documentId": viewKeyResult }];
                }
              } catch (e) {
                console.warn('ViewKey evaluation failed:', e);
              }
            }
            
            // For image types, we need to fetch from DMS
            if (processingItem['documentIds']?.[0]?.documentId) {
              const docId = processingItem['documentIds'][0]?.documentId;
              const url = this?.baseService?.getApiEndpoint("dms") + 'emrImage' + 
                        '/image-response-entity?args=id:' + docId + '&application=dms';
              
              try {
                const blob = await this?.baseService?.getFileByUrl(url, false).toPromise();
                resolve(blob);
                return;
              } catch (error) {
                reject(error);
                return;
              }
            }
          }
        }

        // ============================================================
        // CONDITION 7: PDF TYPE HANDLING
        // ============================================================
        if (processingItem['view_selected_config']['type'] === 'pdf') {
          if (!processingItem['view_selected_config']?.url) {
            reject(new Error('PDF type but URL missing'));
            return;
          }

          // --- PDF Sub-Scenario A: DMS Non-S3 Storage ---
          if (processingItem?.s3 == undefined &&
              processingItem?.document_id &&
              processingItem?.document_id !== '') {

            const url = this?.baseService?.getApiEndpoint("dms") + 'emrImage' +
                      '/image-response-entity?args=id:' + processingItem?.document_id +
                      '&application=dms';
            
            try {
              const blob = await this?.baseService?.getFileByUrl(url, false).toPromise();
              resolve(blob);
              return;
            } catch (error) {
              reject(error);
              return;
            }
          }

          // --- PDF Sub-Scenario B: Print Engine Template Substitution ---
          if (processingItem['view_selected_config']?.reportTemplateId != undefined && 
              processingItem['view_selected_config']?.reportTemplateId !== "") {
            let file_url = processingItem['view_selected_config']?.url;
            if (file_url?.indexOf('!!!application_name!!!') > -1) {
              file_url = file_url?.replace('!!!application_name!!!', 'printengine');
              processingItem['view_selected_config'].url = file_url;
            }
          }

          // --- PDF Sub-Scenario C: S3 Storage ---
          if (processingItem?.s3 != undefined && 
              processingItem?.s3 && 
              processingItem?.document_id && 
              processingItem?.document_id !== '') {
            
            const url = this?.baseService?.getApiEndpoint("dms") + 
                      this?.currentData?.document_type + 
                      '/image-response-entity?path=' + processingItem?.document_id + 
                      '&application=dms';

            try {
              const blob = await this?.baseService?.getFileByUrl(url, false).toPromise();
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error('Failed to fetch S3 document'));
              }
              return;
            } catch (error) {
              reject(error);
              return;
            }
          }

          // --- PDF Sub-Scenario D: Generate from URL ---
          if (processingItem?.document_id == undefined ||
              processingItem?.document_id === '' ||
              (!processingItem?.s3 && processingItem?.document_id !== '')) {

            try {
              // Check if URL should be executed (expression-based)
              let getUrl = true;
              if (processingItem['view_selected_config']?.expression != undefined) {
                try {
                  getUrl = eval(processingItem['view_selected_config']?.expression);
                } catch (e) {
                  console.warn('PDF expression evaluation failed:', e);
                  getUrl = false;
                }
              }

              if (!getUrl) {
                reject(new Error('URL expression evaluated to false'));
                return;
              }

              // Build URL
              let url = location?.origin + processingItem['view_selected_config']?.url;

              if (url?.indexOf('!!!application_name!!!') !== -1) {
                url = url?.replace('!!!application_name!!! ', 'printengine');
              }
              
              if (url?.indexOf('!!!') !== -1) {
                url = this?.baseService.buildDyanamicStr(url, { data: processingItem });
              }

              if (this.currentData?.ehr_view) {
                url = url + "&read_scope_level=account";
              }
              
              // Fetch the blob
              const blob = await this?.baseService?.getFileByUrl(url, false).toPromise();
              
              if (blob && blob instanceof Blob) {
                resolve(blob);
              } else {
                reject(new Error('Invalid blob received from URL'));
              }
              return;
            } catch (error) {
              reject(error);
              return;
            }
          }
        }

        // ============================================================
        // CONDITION 8: FORM TYPE HANDLING
        // ============================================================
        if (processingItem['view_selected_config']['type'] === 'form') {
          if (processingItem['view_selected_config']?.formsource != undefined) {
            let shouldProcessForm = true;
            
            // Check expression
            try {
              if (processingItem['view_selected_config']?.expression != undefined) {
                shouldProcessForm = eval(processingItem['view_selected_config']?.expression);
              }
            } catch (e) {
              console.warn('Form expression check failed:', e);
              shouldProcessForm = false;
            }

            if (shouldProcessForm) {
              const formsource = JSON.parse(JSON.stringify(
                processingItem['view_selected_config']?.formsource
              ));
              
              if (formsource?.args != undefined && formsource?.args?.indexOf('!!!') != -1) {
                formsource.args = this?.baseService?.buildDyanamicStr(
                  formsource?.args, 
                  { data: processingItem }
                );
              }
              
              try {
                const res = await this?.baseService?.getData(
                  { args: formsource?.args }, 
                  "", 
                  formsource?.resource, 
                  formsource?.application, 
                  formsource?.queryId
                ).toPromise();
                
                // Form types typically return JSON/HTML, convert to blob
                const formBlob = new Blob([JSON.stringify(res)], { type: 'application/json' });
                resolve(formBlob);
                return;
              } catch (error) {
                reject(error);
                return;
              }
            }
          }
        }

        // ============================================================
        // CONDITION 9: GRID TYPE HANDLING
        // ============================================================
        if (processingItem['view_selected_config']['type'] === 'grid') {
          if (processingItem['view_selected_config']?.gridSource != undefined) {
            // Grid types need special handling - typically shown in UI, not printed
            reject(new Error('Grid type cannot be printed directly'));
            return;
          }
        }

        // ============================================================
        // CONDITION 10: Special list.view_config Handling
        // ============================================================
        if (processingItem?.view_config && processingItem?.view_config?.length > 0) {
          const viewConfig = processingItem?.view_config[0];
          
          // PDF from list.view_config
          if (viewConfig['type'] === 'pdf' && viewConfig.url != undefined) {
            let getUrl = true;
            if (viewConfig?.expression != undefined) {
              try {
                // Use processingItem. item if it exists, else processingItem itself
                const item = processingItem?.item || processingItem;
                getUrl = eval(viewConfig?.expression);
              } catch (e) {
                console.warn('list.view_config expression check failed:', e);
                getUrl = false;
              }
            }

            if (!getUrl) {
              reject(new Error('Expression check failed for list.view_config'));
              return;
            }

            try {
              let url = location?.origin + viewConfig?.url;
              if (url.indexOf('!!!') !== -1) {
                url = this?.baseService?.buildDyanamicStr(url, { data: processingItem });
              }

              const blob = await this?.baseService?.getFileByUrl(url, false).toPromise();
              resolve(blob);
              return;
            } catch (error) {
              reject(error);
              return;
            }
          }

          // GRID from list.view_config
          if (viewConfig['type'] === 'GRID' && viewConfig?.datasource != undefined) {
            reject(new Error('GRID type from view_config cannot be printed directly'));
            return;
          }
        }

        // ============================================================
        // FALLBACK: No valid scenario matched
        // ============================================================
        reject(new Error('No valid document source or type found'));
        
      } catch (error) {
        console.error('Error in fetchPDFBlobForPrint:', error);
        reject(error);
      }
    });
  }

/*================ END: CUMULATIVE PRINTING LOGIC FOR PRESCRIPTION HISTORY =================*/

  /** Loads the template copy rule; only flag_value false restricts copy, any error or other response allows it. */
  checkCopyRule() {
    this.baseService.get('CHECK_RULE_FOR_EMR', 'rule_name:TEMPLATE_COPY_FUNCTIONALITY_EMR', 'observation_emr_templates', 'emr', undefined, undefined, { cache: true }).subscribe((res: any) => {
      this.copyRuleAllowed = !(res?.errCode == 0 && res.resource?.[0]?.['flag_value'] == false);
      this.copyRuleRemark = res?.resource?.[0]?.['remarks'] || '';
    },() => { this.copyRuleAllowed = true; });
  }

}
